import ReactToPrint from 'react-to-print';
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import './ProjectDetailsCSS/contractorDetails.css';
import './ProjectDetailsCSS/milestone.css';
import './ProjectDetailsCSS/progress.css';
import { ToastContainer, toast } from "react-toastify";
import { formatDateDD_MM_YYYY, formattedDateLong } from "../Date";
import { BASE_URL } from "../../config/axios";
import { AddProjectBill, AddEOTDetails, AddCOSDetails, AddMilstoneDetails, AddTrackRecordDetails, UpdateTrackRecordDetails, AddProgressdetails, DeleteBillingDetails, UpdateBill, UpdateProjectBill, ViewAmountModel, DeleteBg, DeleteInsurance, AddInsurance, AddBankGuarantee, UpdateContractor, DeleteContractor, UpdateBankGuarantee, UpdateBank, UpdateInsurance, UpdateEOTDetails, DeleteEOT, DeleteTrackAndLetterDetails, DeleteCOS, UpdateTrackRecordDetailwithIDonly, UpdateConsultantDetails, AssociatedLetters, DocumentModel, DeleteDocuments, UpdateProgressdetails, UpdateCOSDetails, UpdateMilestone, DeleteMileStone, AllAssociateLetter, Updatedocument } from "./ProjectDetailsCrudButtons";
import { AddSiteEmployee, UpdateSiteEmployee, DeleteSiteEmployee, UploadSiteEmployee } from "../Wfm/WorkforceCrudButton";
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, YAxis, LineChart } from 'recharts';
import usePermission from "../../config/permissions";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { formatCurrencyIndian, sortProjects, handleErrorToast, formatRoundoffCrores, formatRoundoff, isEditable, CustomModel, ViewLetterModal, Lock } from "../CustomFunctions";
import { CircularGrid, DeleteDustbin, DocumentIcon, LockButton, SearchBig, SearchSmall } from '../AllSvg';
import { LetterStatus, LetterType, StatusFilter } from '../FilterDropdown';
import { UploadBGBulk, UploadBillingBulk, UploadcosBulk, UploadEotBulk, UploadInsuranceBulk, UploadLetterBulk, UploadMilestoneBulk, UploadSiteProgressBulk } from './BulkModals';
import { Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { AddLetterLinked } from '../../pages/sitedashboard/Main/LetterTracking';
import Item from 'antd/es/list/Item';
import AllAssociatedLetters from './AllAssociatedLetters';
import zIndex from '@mui/material/styles/zIndex';
import { Activity, Award, BarChart3, Briefcase, Building2, Calendar, CheckCircle, ChevronDown, ChevronUp, Clock, IndianRupee, FileText, MapPin, Target, Trash2, TrendingUp, Users, Zap, Plus, Layers, Flag, Cross, XCircle, AlertCircle, MessageCircle } from 'lucide-react';


const ConsultancyDetails = ({ projectId, siteSubCompanyList, projectData, getProjects, buffer, site_prcode }) => {
  // console.log(projectData, projectId, siteSubCompanyList, 'projetcs')
  const role = sessionStorage.getItem('sitemanagement_role');

  const insuranceData = projectData?.insurance || [];

  const [toggleState, setToggleState] = useState("active");
  const [insurancefilterdata, setInsuranceFilterData] = useState([]);


  useEffect(() => {
    let data = [];
    if (toggleState === "active") {
      const today = new Date();

      data = insuranceData.filter((i) => {
        const validUpto = new Date(i.insurance_policy_valid_upto_date);
        return validUpto >= today;
      });

    }
    else if (toggleState === "inactive") {
      const today = new Date();

      data = insuranceData.filter((i) => {
        const validUpto = new Date(i.insurance_policy_valid_upto_date);
        return validUpto <= today;
      });
    }
    else {
      data = insuranceData;

    }
    setInsuranceFilterData(data);
  }, [toggleState, insuranceData])


  const bgData = projectData?.bgdetails || [];

  const [togglebg, setTogglebg] = useState("active");
  const [bgfilterdata, setbgFilterData] = useState([]);

  useEffect(() => {
    let data = [];
    if (togglebg === "active") {
      const today = new Date();

      data = bgData.filter((i) => {
        const validUpto = new Date(i.bg_expiry_date);
        return validUpto >= today;
      });

    }
    else if (togglebg === "inactive") {
      const today = new Date();

      data = bgData.filter((i) => {
        const validUpto = new Date(i.bg_expiry_date);
        return validUpto <= today;
      });
    }
    else {
      data = bgData;

    }
    setbgFilterData(data);
  }, [togglebg, bgData])




  return (
    <>

      <div className="info-box-div-bg">
        <div>
          <div className="jd-heading-outer-flex ">
            <h2 className="jd-heading-main font-weight600  font-size-heading">Consultant Details</h2>
            {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" && (
              <>
                {projectData?.lock === false ?
                  <div className="field-cont">
                    <UpdateConsultantDetails
                      i={projectData}
                      getProjects={getProjects}
                      siteSubCompanyList={siteSubCompanyList}
                    />
                  </div> :
                  <div className="lock-button">
                    <LockButton />
                  </div>
                }
              </>

            )}


          </div>
          <div>
            <div className="jd-heading-bottom-bold"></div>
            <div className="jd-heading-bottom-light"></div>
          </div>
        </div>

        <div className="info-box-div">
          <div className="personal-detail">

            {buffer ? <div className="spinner-smalll"></div> :
              <table className="width-40vw">
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Tender Id</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.tender_id ? projectData?.tender_id : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Client</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.client_name ? projectData?.client_name : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Lead Partner</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.lead ? projectData?.lead : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">JV Partner</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.jv ? projectData?.jv : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Association Partner</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.association ? projectData?.association : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Lead Partner Share (%)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.our_share ? projectData?.our_share : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">JV Partner Share (%)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.jv_share ? projectData?.jv_share : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Association  Partner Share (%)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.associate_partner_share ? projectData?.associate_partner_share : "-"}</th>
                </tr >

                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Work Type</td>
                  <th className="personal-detail-2 font-weight500 font-size-text form-text-trasformation-alluppercase">{projectData?.work_type ? projectData?.work_type : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Contract Mode</td>
                  <th className="personal-detail-2 font-weight500 font-size-text form-text-trasformation-alluppercase ">{projectData?.contract_mode ? projectData?.contract_mode : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Authorized AE/IE</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.athorized_IE_AE ? projectData?.athorized_IE_AE : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Authority Engineer</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.concern_person_name ? projectData?.concern_person_name : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text">Coordinator</td>
                  <th className="personal-detail-2 font-weight500 font-size-text">
                    {projectData?.com_operators_names?.length
                      ? projectData.com_operators_names.map(name => name.trim()).join(", ")
                      : "-"}
                  </th>
                </tr>

                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Project Length (in Km)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.project_length ? projectData?.project_length : "-"}</th>
                </tr >
                <tr>

                  <td className="personal-detail-1 font-weight500 font-size-text ">Construction Duration (in Months)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.construction_duration ? projectData?.construction_duration : "-"}</th>
                </tr >
                <tr>

                  <td className="personal-detail-1 font-weight500 font-size-text ">O & M Duration(in Months)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.om_duration ? projectData?.om_duration : "-"}</th>
                </tr >
                <tr>

                  <td className="personal-detail-1 font-weight500 font-size-text ">Project Duration (in Months)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.project_duration ? projectData?.project_duration : "-"}</th>
                </tr >


              </table >
            }
          </div>
          <div className="personal-detail">
            {buffer ? <div className="spinner-smalll"></div> :
              <table className="width-40vw">
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Consultancy Fees</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">Rs. {formatRoundoffCrores(projectData?.consultancy_fees)}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Bid Due Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.bid_due_date ? formattedDateLong(projectData?.bid_due_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Consultant LOA Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.loa_award_date ? formattedDateLong(projectData?.loa_award_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Agreement Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.agreement_date ? formattedDateLong(projectData?.agreement_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Commencement Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.commencement_date ? formattedDateLong(projectData?.commencement_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Mobilization Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.mobilization ? formattedDateLong(projectData?.mobilization) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Construction Completion Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.schedule_construction_completion_date ? formattedDateLong(projectData?.schedule_construction_completion_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Actual Construction Completion Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.actual_construction_completion_date ? formattedDateLong(projectData?.actual_construction_completion_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Completion Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.schedule_completion_date ? formattedDateLong(projectData?.schedule_completion_date) : "-"}</th>
                </tr >
                {/* <tr>
                    <td className="personal-detail-1 font-weight500 font-size-text ">Project Completion Date</td>
                    <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.project_completion_date ? formattedDateLong(projectData?.project_completion_date) : "-"}</th>
                  </tr > */}
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Actual Completion Date</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.actual_completion_date ? formattedDateLong(projectData?.actual_completion_date) : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Employee Count</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.employees?.length}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Extension of Time Count</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.eots?.filter(eot => eot.workperformedby === "consultant").length}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Remark</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.remark ? projectData?.remark : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Location (State)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.location ? projectData?.location : "-"}</th>
                </tr >
                {/* <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Site Sub Company</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.sub_company ? projectData?.sub_company : "-"}</th>
                </tr > */}

                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Regional Office Name (RO Name)</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.ro ? projectData?.ro : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Site Office Address</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.site_office_address ? projectData?.site_office_address : "-"}</th>
                </tr >
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text ">Client Address</td>
                  <th className="personal-detail-2 font-weight500 font-size-text ">{projectData?.client_address ? projectData?.client_address : "-"}</th>
                </tr >
              </table >
            }
          </div >

        </div >

        <div>
          <div>
            <div className="jd-heading-outer-flex ">
              <div className='flex-row'>
                <h2 className="jd-heading-main font-weight600  font-size-heading">Insurance

                </h2>
                {role !== "SiteManagement" && role !== "Checker" &&
                  <p>
                    {

                      projectData?.insurance?.length < 4 ? (
                        <p className='insurance-div paragraph' style={{ color: "red" }}>(At least 4 insurance entries are required. Please add more.)</p>



                      ) : (null)

                    }
                  </p>
                }
              </div>
              <div className="field-cont">
                {role === "SiteManagement" || role === "Checker" ?
                  "" :
                  <>
                    <StatusFilter togglestatus={toggleState} settoggleStatus={setToggleState} />
                    {role !== "ViewAccess" &&
                      <AddInsurance project={projectId} getProjects={getProjects} />
                    }
                    {/* {role === "Admin" && <UploadInsuranceBulk getInsurance={getProjects} projectData={projectData} site_prcode={site_prcode} />} */}
                  </>
                }
              </div>
            </div>
            <div>
              <div className="jd-heading-bottom-bold"></div>
              <div className="jd-heading-bottom-light"></div>
            </div>
            <br />
          </div>

          <>
            <div className="form-flex-wrap scroll-container-table child-table-scroll">
              <table className="table-css ">
                <thead className='table-heading'>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text text-lefttt ">S.No.</th>
                    <th className="table-heading-text text-center">Policy Number</th>
                    <th className="table-heading-text text-center">Insurance Name</th>
                    <th className="table-heading-text text-center">Amount</th>
                    <th className="table-heading-text text-center">Start Date </th>
                    <th className="table-heading-text text-center">Valid Upto</th>
                    <th className="table-heading-text text-center">File</th>
                    {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" &&
                      <th className="table-heading-text text-center">Action</th>
                    }
                  </tr>
                </thead>
                {buffer ? (
                  <div className="sspinner-bgdatil"></div>
                ) : (
                  <tbody>
                    {insurancefilterdata.map((billData, monthIndex) => (
                      <React.Fragment key={monthIndex}>
                        <tr className="custom-table-head-td" style={(() => {
                          const today = new Date();
                          const expiry = new Date(billData.insurance_policy_valid_upto_date);

                          const oneMonthBefore = new Date(expiry);
                          oneMonthBefore.setMonth(expiry.getMonth() - 1);

                          if (expiry < today) {
                            return { backgroundColor: "#f72b50", color: "white" }; // expired → red bg + white text
                          } else if (today >= oneMonthBefore && today <= expiry) {
                            return { backgroundColor: "#f7941e", color: "black" }; // expiring soon → orange bg
                          } else {
                            return { backgroundColor: "transparent", color: "black" }; // normal
                          }
                        })()}

                        >
                          <td style={{ color: "inherit", paddingLeft: "10px" }} className="table-body text-left">{`${monthIndex + 1}.`}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">{billData.insurance_policy_num}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">{billData.insurance_name}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">{billData.insurance_amount}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">{formattedDateLong(billData.insurance_policy_start_date)}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">{formattedDateLong(billData.insurance_policy_valid_upto_date)}</td>
                          <td style={{ color: "inherit" }} className="table-body text-center">
                            {!billData.insurance_file_upload ? <>File Not Attacted</> : <a href={billData.insurance_file_upload} target="blank" className="">
                              < DocumentIcon />
                            </a>}
                          </td>
                          {role === "SiteManagement" || role === "Checker" || role === "ViewAccess" ?
                            "" :
                            <td className="table-body text-end flex-row justify-center">
                              {
                                billData.lock === false &&

                                <UpdateInsurance i={billData} getProjects={getProjects} />
                              }
                              {role === "Admin" &&
                                <Lock apiName="insurance" id={billData.id} i={billData} usedFor="Insurance" getData={getProjects} />
                              }
                              <>
                                {
                                  billData.lock === false &&

                                  <DeleteInsurance i={billData} getInsuranceData={getProjects} />
                                }
                              </>
                            </td>
                          }
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                )}

              </table>
            </div>

          </>
        </div>

        <div>
          <div>
            <div className="jd-heading-outer-flex ">
              <h2 className="jd-heading-main font-weight600  font-size-heading">Bank / Performance Guarantee</h2>
              <div className="field-cont">
                {role !== "SiteManagement" && role !== "Checker" &&
                  <>
                    <StatusFilter togglestatus={togglebg} settoggleStatus={setTogglebg} />
                    {
                      role !== "ViewAccess" &&
                      <AddBankGuarantee project={projectId} getbg={getProjects} />
                    }
                    {/* {role === "Admin" && <UploadBGBulk getBankGuarantee={getProjects} projectData={projectData} site_prcode={site_prcode} />} */}
                  </>
                }

              </div>
            </div>
            <div>
              <div className="jd-heading-bottom-bold"></div>
              <div className="jd-heading-bottom-light"></div>
            </div>
            <br />
          </div>

          <>
            <div className='form-flex-wrap scroll-container-table child-table-scroll'>
              <table className="table-css ">
                <thead className='table-heading'>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text text-lefttt">S.No.</th>
                    <th className="table-heading-text text-center">Bank Name</th>
                    <th className="table-heading-text text-center">Bank Number</th>
                    <th className="table-heading-text text-center">Amount</th>
                    <th className="table-heading-text text-center">Start Date</th>
                    <th className="table-heading-text text-center">Expiry Date</th>
                    <th className="table-heading-text text-center">Remarks</th>
                    <th className="table-heading-text text-center">Document </th>
                    {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" &&
                      <th className="table-heading-text text-center">Action</th>
                    }
                  </tr>
                </thead>
                {buffer ? (
                  <div className="spinner-bgdatil"></div>
                ) : (
                  <tbody>
                    {bgfilterdata
                      .map((billData, monthIndex) => (
                        <React.Fragment key={monthIndex}>
                          <tr className="custom-table-head-td"
                            style={(() => {
                              const today = new Date();
                              const expiry = new Date(billData.bg_expiry_date);

                              const oneMonthBefore = new Date(expiry);
                              oneMonthBefore.setMonth(expiry.getMonth() - 1);

                              if (expiry < today) {
                                return { backgroundColor: "#f72b50", color: "white" }; // expired → red bg + white text
                              } else if (today >= oneMonthBefore && today <= expiry) {
                                return { backgroundColor: "#f7941e", color: "black" }; // expiring soon → orange bg
                              } else {
                                return { backgroundColor: "transparent", color: "black" }; // normal
                              }
                            })()}
                          >
                            <td style={{ color: "inherit", paddingLeft: "10px" }} className="table-body text-left">{`${monthIndex + 1}.`}</td>
                            <td style={{ color: "inherit" }} className="table-body text-center">{billData.bank_name}</td>
                            <td style={{ color: "inherit" }} className="table-body text-center">{billData.bg_num}</td>
                            <td style={{ color: "inherit" }} className="table-body text-center">{billData.bg_amount}</td>

                            <td style={{ color: "inherit" }} className="table-body text-center">{formattedDateLong(billData.bg_date)}</td>
                            <td style={{ color: "inherit" }} className="table-body text-center">{formattedDateLong(billData.bg_expiry_date)}</td>

                            <td style={{ color: "inherit" }} className="table-body text-center">{billData.bg_remark}</td>
                            <td className="table-body text-center">
                              {!billData.bg_document ? <>File Not Attached</> : <a href={billData.bg_document} target="blank" className="">
                                < DocumentIcon />
                              </a>}
                            </td>

                            {role === "SiteManagement" || role === "Checker" || role === "ViewAccess" ?
                              ""
                              :
                              <td className="table-body text-end flex-row justify-center">
                                {
                                  billData.lock === false &&

                                  <UpdateBankGuarantee i={billData} getbg={getProjects} />
                                }
                                {role === "Admin" &&
                                  <Lock apiName="bgdetails" id={billData.id} i={billData} usedFor="Bank Guarantee" getData={getProjects} />
                                }
                                {
                                  billData.lock === false &&

                                  <DeleteBg i={billData} getbg={getProjects} />
                                }
                              </td>
                            }


                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                )}
              </table>
            </div>

          </>
        </div>


      </div >
    </>
  )
}

// const ContractorDetails = ({ contractor, getProjects, getContractorDetails }) => {

//   const role = sessionStorage.getItem('sitemanagement_role');

//   const [buffer, setBuffering] = useState(false);
//   const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);


//   useEffect(() => {

//     getConsultancyDetails();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [contractor]);

//   const getConsultancyDetails = async () => {
//     setBuffering(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${contractor}/`);
//       setConsultancyDetailsData(res.data);
//     } catch (err) {
//     } finally {
//       setBuffering(false);
//     }
//   };





//   const formatRoundoff = (amount) => {
//     if (amount === null || amount === undefined) return "-";

//     // Function to format the number with Indian number system
//     const formatIndianStyle = (num) => {
//       let numStr = num.toString();
//       let lastThreeDigits = numStr.slice(-3);
//       let otherDigits = numStr.slice(0, -3);

//       if (otherDigits) {
//         lastThreeDigits = ',' + lastThreeDigits;
//       }

//       // Split other digits into groups of two and add commas
//       const formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

//       return formattedOtherDigits + lastThreeDigits;
//     };



//     return formatIndianStyle(amount)
//   };



//   return (
//     <>

//       <div className="info-box-div-bg">

//         <div className="heading-bg-color-white">
//           <div className="jd-heading-outer-flex ">
//             <h2 className="jd-heading-main font-weight600  font-size-heading">Contractors</h2>
//             <div className="field-cont">
//               {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" &&
//                 <>
//                   {
//                     consultancyDetailsDetails?.lock === false &&

//                     <UpdateContractor contractor={contractor} getContractorDetails={getConsultancyDetails} projectId={consultancyDetailsDetails?.project} i={consultancyDetailsDetails} />
//                   }
//                   {role === "Admin" &&
//                     <Lock apiName="contractor" id={consultancyDetailsDetails?.id} i={consultancyDetailsDetails} usedFor="Contractor" getData={getConsultancyDetails} />
//                   }
//                   {
//                     consultancyDetailsDetails?.lock === false &&
//                     <DeleteContractor contractor={contractor} getProjectContractorDetails={getContractorDetails} getproject={getProjects} />
//                   }
//                 </>
//               }

//             </div>
//           </div>
//           <div>
//             <div className="jd-heading-bottom-bold"></div>
//             <div className="jd-heading-bottom-light"></div>
//           </div>
//         </div>


//         <div className="info-box-div">
//           <div className="personal-detail">

//             {buffer ? <div className="spinner-smalll"></div> :
//               <table className="width-40vw">
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Name</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.name ? consultancyDetailsDetails?.name : "-"}</th>
//                 </tr >

//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Cost Before COS</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">Rs. {consultancyDetailsDetails?.cost ? formatRoundoff(consultancyDetailsDetails.cost) : "0"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Approved COS Amount</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">Rs. {consultancyDetailsDetails?.linked_cos?.total_approved_amount ? formatRoundoff(consultancyDetailsDetails?.linked_cos?.total_approved_amount) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Cost After COS</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">Rs. {consultancyDetailsDetails?.linked_cos ? formatRoundoff(consultancyDetailsDetails.cost_with_cos) : "-"}</th>
//                 </tr >


//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Project Length (in Km)</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.project_length ? consultancyDetailsDetails?.project_length : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Construction Duration (in Months)</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.construction_duration ? consultancyDetailsDetails?.construction_duration : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">O&M Duration (in Months)</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.OM_duration ? consultancyDetailsDetails?.OM_duration : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Project Duration (in Months)</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.project_duration ? consultancyDetailsDetails?.project_duration : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Total Extension of Time Count</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.linked_eots ? consultancyDetailsDetails?.linked_eots.items.length : "0"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Approved Extension of Time Count</td>
//                   <th className='personal-detail-2 font-weight500 font-size-text'>
//                     {consultancyDetailsDetails?.linked_eots
//                       ? consultancyDetailsDetails.linked_eots.items.filter(
//                         (item) => item.approved_days === "0"
//                       ).length
//                       : "0"}
//                   </th>

//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Approved EOT Days Count</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.EOT_Days ? consultancyDetailsDetails?.EOT_Days : "0"} days</th>
//                 </tr >

//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">COS of Count</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.linked_cos ? consultancyDetailsDetails?.linked_cos.items.length : "0"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Approved COS Count</td>
//                   <th className='personal-detail-2 font-weight500 font-size-text'>
//                     {consultancyDetailsDetails?.linked_cos
//                       ? consultancyDetailsDetails.linked_cos.items.filter(
//                         (item) => item.approved_amount === "0"
//                       ).length
//                       : "0"}
//                   </th>

//                 </tr >



//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Address</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.contractor_address ? consultancyDetailsDetails?.contractor_address : "-"}</th>
//                 </tr >



//               </table >
//             }
//           </div >
//           <div className="personal-detail">
//             {buffer ? <div className="spinner-smalll"></div> :
//               <table className="width-40vw">
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Bid Due Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.contractor_bid_due_date ? formattedDateLong(consultancyDetailsDetails?.contractor_bid_due_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">LOA Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.loa_award_date ? formattedDateLong(consultancyDetailsDetails?.loa_award_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Agreement Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.agreement_date ? formattedDateLong(consultancyDetailsDetails?.agreement_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Appointed Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.commencement_date ? formattedDateLong(consultancyDetailsDetails?.commencement_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Construction Completion Date Before EOT</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.schedule_construction_completion_date ? formattedDateLong(consultancyDetailsDetails?.schedule_construction_completion_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Construction Completion Date After EOT</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.schedule_construction_completion_date_with_eot !== "1970-01-01" ? formattedDateLong(consultancyDetailsDetails?.schedule_construction_completion_date_with_eot) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Actual Construction Completion Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.actual_construction_completion_date ? formattedDateLong(consultancyDetailsDetails?.actual_construction_completion_date) : "-"}</th>
//                 </tr >
//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Schedule Completion Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.schedule_completion_date ? formattedDateLong(consultancyDetailsDetails?.schedule_completion_date) : "-"}</th>
//                 </tr >

//                 <tr>
//                   <td className="personal-detail-1 font-weight500 font-size-text ">Actual Completion Date</td>
//                   <th className="personal-detail-2 font-weight500 font-size-text ">{consultancyDetailsDetails?.actual_completion_date ? formattedDateLong(consultancyDetailsDetails?.actual_completion_date) : "-"}</th>
//                 </tr >



//               </table >
//             }
//           </div >




//         </div >
//       </div>

//     </>
//   )
// }



// const ContractorDetails = ({ projectId, contractor, getProjects, getContractorDetails }) => {
//   const role = sessionStorage.getItem('sitemanagement_role');
//   const [buffer, setBuffering] = useState(false);
//   const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);
//   const [eotList, setEotList] = useState([]);

//   const getEot = async () => {
//     try {
//       let eot = await axios.get(`${BASE_URL}/siteproject/eotfilter/${projectId}/contractor/${contractor}/Approved/`);
//       setEotList(eot.data);
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//     }
//   };
//   useEffect(() => {
//     if (contractor) {
//       getConsultancyDetails();
//       getEot();
//     }
//   }, [contractor]);




//   const getConsultancyDetails = async () => {
//     setBuffering(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${contractor}/`);
//       setConsultancyDetailsData(res.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const formatRoundoff = (amount) => {
//     if (amount === null || amount === undefined) return "-";
//     const formatIndianStyle = (num) => {
//       let numStr = num.toString();
//       let lastThreeDigits = numStr.slice(-3);
//       let otherDigits = numStr.slice(0, -3);
//       if (otherDigits) {
//         lastThreeDigits = ',' + lastThreeDigits;
//       }
//       const formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
//       return formattedOtherDigits + lastThreeDigits;
//     };
//     return formatIndianStyle(amount);
//   };

//   const formatDate = (date) => {
//     if (!date || date === "1970-01-01") return "-";
//     return new Date(date).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };

//   // Prepare table data
//   const basicInfoRows = [
//     { label: "Contractor Name", value: consultancyDetailsDetails?.name || "-", icon: Building2 },
//     { label: "Address", value: consultancyDetailsDetails?.contractor_address || "-", icon: MapPin },
//     { label: "Project Length", value: consultancyDetailsDetails?.project_length ? `${consultancyDetailsDetails.project_length} KM` : "-", icon: TrendingUp },
//     { label: "Construction Duration", value: consultancyDetailsDetails?.construction_duration ? `${consultancyDetailsDetails.construction_duration} Months` : "-", icon: Clock },
//     { label: "O&M Duration", value: consultancyDetailsDetails?.OM_duration ? `${consultancyDetailsDetails.OM_duration} Months` : "-", icon: Clock },
//     { label: "Project Duration", value: consultancyDetailsDetails?.project_duration ? `${consultancyDetailsDetails.project_duration} Months` : "-", icon: Calendar },
//   ];

//   const financialRows = [
//     { label: "Cost Before COS", value: `₹ ${formatRoundoff(consultancyDetailsDetails?.cost)}`, icon: IndianRupee },
//     { label: "Approved COS Amount", value: `₹ ${formatRoundoff(consultancyDetailsDetails?.linked_cos?.total_approved_amount)}`, icon: Award },
//     { label: "Cost After COS", value: `₹ ${formatRoundoff(Number(consultancyDetailsDetails?.cost) + Number(consultancyDetailsDetails?.linked_cos?.total_approved_amount))}`, icon: TrendingUp },
//   ];

//   const eotRows = [
//     { label: "Total EOT Count", value: consultancyDetailsDetails?.linked_eots?.items?.length || 0, icon: FileText },
//     { label: "Approved EOT Count", value: consultancyDetailsDetails?.linked_eots?.items?.filter(item => item.approved_days !== "0").length || 0, icon: CheckCircle },
//     { label: "Approved EOT Days", value: `${consultancyDetailsDetails?.EOT_Days || 0} days`, icon: Calendar },
//   ];

//   const cosRows = [
//     { label: "Total COS Count", value: consultancyDetailsDetails?.linked_cos?.items?.length || 0, icon: FileText },
//     { label: "Approved COS Count", value: consultancyDetailsDetails?.linked_cos?.items?.filter(item => item.approved_amount !== "0.0").length || 0, icon: CheckCircle },
//   ];

//   const dateRows = [
//     { label: "Bid Due Date", value: formatDate(consultancyDetailsDetails?.contractor_bid_due_date), icon: Calendar },
//     { label: "LOA Date", value: formatDate(consultancyDetailsDetails?.loa_award_date), icon: Calendar },
//     { label: "Agreement Date", value: formatDate(consultancyDetailsDetails?.agreement_date), icon: Calendar },
//     { label: "Appointed Date", value: formatDate(consultancyDetailsDetails?.commencement_date), icon: Calendar },
//     { label: "Schedule Construction Completion (Before EOT)", value: formatDate(consultancyDetailsDetails?.schedule_construction_completion_date), icon: Clock },
//     { label: "Schedule Construction Completion (After EOT)", value: formatDate(consultancyDetailsDetails?.schedule_construction_completion_date_with_eot), icon: Zap },
//     { label: "Actual Construction Completion", value: formatDate(consultancyDetailsDetails?.actual_construction_completion_date), icon: CheckCircle },
//     { label: "Schedule Completion Date", value: formatDate(consultancyDetailsDetails?.schedule_completion_date), icon: Calendar },
//     { label: "Actual Completion Date", value: formatDate(consultancyDetailsDetails?.actual_completion_date), icon: Award },
//   ];

//   return (
//     <div className="contractor-details-minimal">
//       {buffer ? (
//         <div className="minimal-loader">
//           <div className="minimal-spinner"></div>
//         </div>
//       ) : !consultancyDetailsDetails || Object.keys(consultancyDetailsDetails).length === 0 || !consultancyDetailsDetails?.name ? (
//         /* No Record Found State - No header or actions shown */
//         <div className="no-record-found">
//           <div className="no-record-icon animated">
//             <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <defs>
//                 <linearGradient id="rainbow" x1="0%" y1="0%" x2="100%" y2="100%">
//                   <stop offset="0%" stopColor="#ff6b6b" />
//                   <stop offset="25%" stopColor="#feca57" />
//                   <stop offset="50%" stopColor="#48dbfb" />
//                   <stop offset="75%" stopColor="#1dd1a1" />
//                   <stop offset="100%" stopColor="#5f27cd" />
//                 </linearGradient>
//               </defs>

//               <g>
//                 <animateTransform attributeName="transform" type="translate" from="0 0" to="0 -10" dur="1s" repeatCount="indefinite" direction="alternate" />

//                 <circle cx="42" cy="42" r="22" stroke="url(#rainbow)" strokeWidth="4" fill="none" />
//                 <line x1="58" y1="58" x2="78" y2="78" stroke="url(#rainbow)" strokeWidth="4" strokeLinecap="round" />

//                 <circle cx="30" cy="25" r="2" fill="#ff6b6b">
//                   <animate attributeName="opacity" from="0" to="1" dur="1s" repeatCount="indefinite" direction="alternate" />
//                 </circle>
//                 <circle cx="60" cy="25" r="2" fill="#feca57">
//                   <animate attributeName="opacity" from="0" to="1" dur="1.5s" repeatCount="indefinite" direction="alternate" />
//                 </circle>
//                 <circle cx="25" cy="50" r="1.5" fill="#48dbfb">
//                   <animate attributeName="opacity" from="0" to="1" dur="0.8s" repeatCount="indefinite" direction="alternate" />
//                 </circle>
//               </g>
//             </svg>
//           </div>
//           <h4>No Contractor Found</h4>
//           <p>No contractor details are available for this project.</p>

//         </div>
//       ) : (
//         <>
//           {/* Minimal Header - Only shown when data exists */}
//           <div className="minimal-header">
//             <div className="minimal-header-left">
//               <div className="minimal-avatar">
//                 <Building2 size={18} />
//               </div>
//               <div>
//                 <h3 className="minimal-title">Contractor Details</h3>
//                 <p className="minimal-subtitle">{consultancyDetailsDetails?.name || "Contractor Information"}</p>
//               </div>
//             </div>
//             <div className="minimal-actions">
//               {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" && (
//                 <>
//                   {consultancyDetailsDetails?.lock === false && (
//                     <UpdateContractor
//                       contractor={contractor}
//                       getContractorDetails={getConsultancyDetails}
//                       projectId={consultancyDetailsDetails?.project}
//                       i={consultancyDetailsDetails}
//                     />
//                   )}
//                   {role === "Admin" && (
//                     <Lock
//                       apiName="contractor"
//                       id={consultancyDetailsDetails?.id}
//                       i={consultancyDetailsDetails}
//                       usedFor="Contractor"
//                       getData={getConsultancyDetails}
//                     />
//                   )}
//                   {consultancyDetailsDetails?.lock === false && (
//                     <DeleteContractor
//                       contractor={contractor}
//                       getProjectContractorDetails={getContractorDetails}
//                       getproject={getProjects}
//                     />
//                   )}
//                 </>
//               )}
//             </div>
//           </div>

//           <div className="minimal-content">
//             {/* Basic Info */}
//             <div className="minimal-card">
//               <div className="minimal-card-header">
//                 <Briefcase size={14} />
//                 <span>Basic Information</span>
//               </div>
//               <div className="minimal-grid">
//                 {basicInfoRows.map((row, idx) => {
//                   const Icon = row.icon;
//                   return (
//                     <div key={idx} className="minimal-field">
//                       <div className="minimal-field-label">
//                         <Icon size={12} />
//                         <span>{row.label}</span>
//                       </div>
//                       <div className="minimal-field-value">{row.value || "-"}</div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* Financial Info */}
//             <div className="minimal-card">
//               <div className="minimal-card-header">
//                 <IndianRupee size={14} />
//                 <span>Financial Information</span>
//               </div>
//               <div className="minimal-grid financial-grid">
//                 {financialRows.map((row, idx) => {
//                   const Icon = row.icon;
//                   return (
//                     <div key={idx} className={`minimal-field ${row.label.includes('After') ? 'highlight-field' : ''}`}>
//                       <div className="minimal-field-label">
//                         <Icon size={12} />
//                         <span>{row.label}</span>
//                       </div>
//                       <div className="minimal-field-value">{row.value || "-"}</div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* EOT & COS */}
//             <div className="minimal-row">
//               <div className="minimal-card half">
//                 <div className="minimal-card-header">
//                   <Clock size={14} />
//                   <span>Extension of Time</span>
//                 </div>
//                 <div className="minimal-stats">
//                   {eotRows.map((row, idx) => {
//                     const Icon = row.icon;
//                     return (
//                       <div key={idx} className="minimal-stat">
//                         <Icon size={14} />
//                         <div>
//                           <span className="minimal-stat-label">{row.label}</span>
//                           <span className="minimal-stat-value">{row.value || "0"}</span>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>

//               <div className="minimal-card half">
//                 <div className="minimal-card-header">
//                   <Award size={14} />
//                   <span>Change of Scope</span>
//                 </div>
//                 <div className="minimal-stats">
//                   {cosRows.map((row, idx) => {
//                     const Icon = row.icon;
//                     return (
//                       <div key={idx} className="minimal-stat">
//                         <Icon size={14} />
//                         <div>
//                           <span className="minimal-stat-label">{row.label}</span>
//                           <span className="minimal-stat-value">{row.value || "0"}</span>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             {/* Timeline */}
//             <div className="minimal-card">
//               <div className="minimal-card-header">
//                 <Calendar size={14} />
//                 <span>Project Timeline</span>
//               </div>
//               <div className="minimal-timeline">
//                 {dateRows.map((row, idx) => {
//                   const Icon = row.icon;
//                   return (
//                     <div key={idx} className="minimal-timeline-item">
//                       <div className="minimal-timeline-icon">
//                         <Icon size={12} />
//                       </div>
//                       <div className="minimal-timeline-label">{row.label}</div>
//                       <div className="minimal-timeline-value">{row.value || "-"}</div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

const ContractorDetails = ({ projectId, contractor, getProjects, getContractorDetails }) => {
  const role = sessionStorage.getItem('sitemanagement_role');
  const [buffer, setBuffering] = useState(false);
  const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);
  const [eotList, setEotList] = useState([]);

  const getEot = async () => {
    try {
      let eot = await axios.get(`${BASE_URL}/siteproject/eotfilter/${projectId}/contractor/${contractor}/Approved/`);
      setEotList(eot.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  useEffect(() => {
    if (contractor) {
      getConsultancyDetails();
      getEot();
    }
  }, [contractor]);

  const getConsultancyDetails = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${contractor}/`);
      setConsultancyDetailsData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  // ─── EOT Date Calculation (same logic as ProjectContractorView) ───────────
  const eotDateBreakdown = useMemo(() => {
    if (
      !eotList?.length ||
      !consultancyDetailsDetails?.schedule_construction_completion_date
    )
      return null;

    const toDate = (d) => (d ? new Date(d) : null);

    const formatDateDMY = (date) => {
      if (!date) return '-';
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = date.toLocaleString('en-IN', { month: 'short' });
      const yyyy = date.getFullYear();
      return `${dd}-${mmm}-${yyyy}`;
    };

    let schedConstDate = toDate(
      consultancyDetailsDetails.schedule_construction_completion_date
    );
    let schedCompDate = toDate(
      consultancyDetailsDetails.schedule_completion_date
    );

    const approvedEOTs = [...eotList]
      .filter((eot) => eot.eot_status === 'Approved')
      .sort(
        (a, b) =>
          new Date(a.process_initiate_date) - new Date(b.process_initiate_date)
      );

    for (const eot of approvedEOTs) {
      const initiateDate = toDate(eot.process_initiate_date);
      const days = Number(eot.approved_days || 0);

      if (initiateDate <= schedConstDate) {
        // EOT initiated before/on const completion → add to const date
        schedConstDate = new Date(schedConstDate);
        schedConstDate.setDate(schedConstDate.getDate() + days);
      } else {
        // EOT initiated after const completion → add to comp date
        schedCompDate = new Date(schedCompDate);
        schedCompDate.setDate(schedCompDate.getDate() + days);
      }
    }

    return {
      revisedConstDate: formatDateDMY(schedConstDate),
      revisedCompDate: schedCompDate ? formatDateDMY(schedCompDate) : '-',
    };
  }, [eotList, consultancyDetailsDetails]);
  // ─────────────────────────────────────────────────────────────────────────

  const formatRoundoff = (amount) => {
    if (amount === null || amount === undefined) return "-";
    const formatIndianStyle = (num) => {
      let numStr = num.toString();
      let lastThreeDigits = numStr.slice(-3);
      let otherDigits = numStr.slice(0, -3);
      if (otherDigits) {
        lastThreeDigits = ',' + lastThreeDigits;
      }
      const formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      return formattedOtherDigits + lastThreeDigits;
    };
    return formatIndianStyle(amount);
  };

  const formatDate = (date) => {
    if (!date || date === "1970-01-01") return "-";
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Prepare table data
  const basicInfoRows = [
    { label: "Contractor Name", value: consultancyDetailsDetails?.name || "-", icon: Building2 },
    { label: "Address", value: consultancyDetailsDetails?.contractor_address || "-", icon: MapPin },
    { label: "Project Length", value: consultancyDetailsDetails?.project_length ? `${consultancyDetailsDetails.project_length} KM` : "-", icon: TrendingUp },
    { label: "Construction Duration", value: consultancyDetailsDetails?.construction_duration ? `${consultancyDetailsDetails.construction_duration} Months` : "-", icon: Clock },
    { label: "O&M Duration", value: consultancyDetailsDetails?.OM_duration ? `${consultancyDetailsDetails.OM_duration} Months` : "-", icon: Clock },
    { label: "Project Duration", value: consultancyDetailsDetails?.project_duration ? `${consultancyDetailsDetails.project_duration} Months` : "-", icon: Calendar },
  ];

  const financialRows = [
    { label: "Cost Before COS", value: `₹ ${formatRoundoff(consultancyDetailsDetails?.cost)}`, icon: IndianRupee },
    { label: "Approved COS Amount", value: `₹ ${formatRoundoff(consultancyDetailsDetails?.linked_cos?.total_approved_amount)}`, icon: Award },
    { label: "Cost After COS", value: `₹ ${formatRoundoff(Number(consultancyDetailsDetails?.cost) + Number(consultancyDetailsDetails?.linked_cos?.total_approved_amount))}`, icon: TrendingUp },
  ];

  const eotRows = [
    { label: "Total EOT Count", value: consultancyDetailsDetails?.linked_eots?.items?.length || 0, icon: FileText },
    { label: "Approved EOT Count", value: consultancyDetailsDetails?.linked_eots?.items?.filter(item => item.approved_days !== "0").length || 0, icon: CheckCircle },
    {
      label: "Approved EOT Days",
      value: `${eotList.filter(e => e.eot_status === 'Approved').reduce((sum, e) => sum + Number(e.approved_days || 0), 0)} days`,
      icon: Calendar
    },
  ];

  const cosRows = [
    { label: "Total COS Count", value: consultancyDetailsDetails?.linked_cos?.items?.length || 0, icon: FileText },
    { label: "Approved COS Count", value: consultancyDetailsDetails?.linked_cos?.items?.filter(item => item.approved_amount !== "0.0").length || 0, icon: CheckCircle },
  ];

  const dateRows = [
    { label: "Bid Due Date", value: formatDate(consultancyDetailsDetails?.contractor_bid_due_date), icon: Calendar },
    { label: "LOA Date", value: formatDate(consultancyDetailsDetails?.loa_award_date), icon: Calendar },
    { label: "Agreement Date", value: formatDate(consultancyDetailsDetails?.agreement_date), icon: Calendar },
    { label: "Appointed Date", value: formatDate(consultancyDetailsDetails?.commencement_date), icon: Calendar },
    { label: "Grace Period", value: consultancyDetailsDetails?.grace_period ? `${consultancyDetailsDetails.grace_period} days` : "-", icon: Clock },
    {
      label: "Schedule Construction Completion (Before EOT)",
      value: formatDate(consultancyDetailsDetails?.schedule_construction_completion_date),
      icon: Clock
    },
    {
      // ← UPDATED: now uses frontend-calculated revised const date
      label: "Schedule Construction Completion (After EOT)",
      value: eotDateBreakdown?.revisedConstDate || "-",
      icon: Zap
    },
    { label: "Actual Construction Completion", value: formatDate(consultancyDetailsDetails?.actual_construction_completion_date), icon: CheckCircle },
    {
      // ← UPDATED: now uses frontend-calculated revised comp date
      label: "Schedule Completion Date (Before EOT)",
      value: formatDate(consultancyDetailsDetails?.schedule_completion_date),
      icon: Calendar
    },
    {
      // ← UPDATED: now uses frontend-calculated revised comp date
      label: "Schedule Completion Date (After EOT)",
      value: eotDateBreakdown?.revisedCompDate || "-",
      icon: Calendar
    },
    { label: "Actual Completion Date", value: formatDate(consultancyDetailsDetails?.actual_completion_date), icon: Award },
  ];

  return (
    <div className="contractor-details-minimal">
      {buffer ? (
        <div className="minimal-loader">
          <div className="minimal-spinner"></div>
        </div>
      ) : !consultancyDetailsDetails || Object.keys(consultancyDetailsDetails).length === 0 || !consultancyDetailsDetails?.name ? (
        /* No Record Found State - No header or actions shown */
        <div className="no-record-found">
          <div className="no-record-icon animated">
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="rainbow" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#ff6b6b" />
                  <stop offset="25%" stopColor="#feca57" />
                  <stop offset="50%" stopColor="#48dbfb" />
                  <stop offset="75%" stopColor="#1dd1a1" />
                  <stop offset="100%" stopColor="#5f27cd" />
                </linearGradient>
              </defs>

              <g>
                <animateTransform attributeName="transform" type="translate" from="0 0" to="0 -10" dur="1s" repeatCount="indefinite" direction="alternate" />

                <circle cx="42" cy="42" r="22" stroke="url(#rainbow)" strokeWidth="4" fill="none" />
                <line x1="58" y1="58" x2="78" y2="78" stroke="url(#rainbow)" strokeWidth="4" strokeLinecap="round" />

                <circle cx="30" cy="25" r="2" fill="#ff6b6b">
                  <animate attributeName="opacity" from="0" to="1" dur="1s" repeatCount="indefinite" direction="alternate" />
                </circle>
                <circle cx="60" cy="25" r="2" fill="#feca57">
                  <animate attributeName="opacity" from="0" to="1" dur="1.5s" repeatCount="indefinite" direction="alternate" />
                </circle>
                <circle cx="25" cy="50" r="1.5" fill="#48dbfb">
                  <animate attributeName="opacity" from="0" to="1" dur="0.8s" repeatCount="indefinite" direction="alternate" />
                </circle>
              </g>
            </svg>
          </div>
          <h4>No Contractor Found</h4>
          <p>No contractor details are available for this project.</p>
        </div>
      ) : (
        <>
          {/* Minimal Header - Only shown when data exists */}
          <div className="minimal-header">
            <div className="minimal-header-left">
              <div className="minimal-avatar">
                <Building2 size={18} />
              </div>
              <div>
                <h3 className="minimal-title">Contractor Details</h3>
                <p className="minimal-subtitle">{consultancyDetailsDetails?.name || "Contractor Information"}</p>
              </div>
            </div>
            <div className="minimal-actions">
              {role !== "SiteManagement" && role !== "Checker" && role !== "ViewAccess" && (
                <>
                  {consultancyDetailsDetails?.lock === false && (
                    <UpdateContractor
                      contractor={contractor}
                      getContractorDetails={getConsultancyDetails}
                      projectId={consultancyDetailsDetails?.project}
                      i={consultancyDetailsDetails}
                    />
                  )}
                  {role === "Admin" && (
                    <Lock
                      apiName="contractor"
                      id={consultancyDetailsDetails?.id}
                      i={consultancyDetailsDetails}
                      usedFor="Contractor"
                      getData={getConsultancyDetails}
                    />
                  )}
                  {consultancyDetailsDetails?.lock === false && (
                    <DeleteContractor
                      contractor={contractor}
                      getProjectContractorDetails={getContractorDetails}
                      getproject={getProjects}
                    />
                  )}
                </>
              )}
            </div>
          </div>

          <div className="minimal-content">
            {/* Basic Info */}
            <div className="minimal-card">
              <div className="minimal-card-header">
                <Briefcase size={14} />
                <span>Basic Information</span>
              </div>
              <div className="minimal-grid">
                {basicInfoRows.map((row, idx) => {
                  const Icon = row.icon;
                  return (
                    <div key={idx} className="minimal-field">
                      <div className="minimal-field-label">
                        <Icon size={12} />
                        <span>{row.label}</span>
                      </div>
                      <div className="minimal-field-value">{row.value || "-"}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Financial Info */}
            <div className="minimal-card">
              <div className="minimal-card-header">
                <IndianRupee size={14} />
                <span>Financial Information</span>
              </div>
              <div className="minimal-grid financial-grid">
                {financialRows.map((row, idx) => {
                  const Icon = row.icon;
                  return (
                    <div key={idx} className={`minimal-field ${row.label.includes('After') ? 'highlight-field' : ''}`}>
                      <div className="minimal-field-label">
                        <Icon size={12} />
                        <span>{row.label}</span>
                      </div>
                      <div className="minimal-field-value">{row.value || "-"}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* EOT & COS */}
            <div className="minimal-row">
              <div className="minimal-card half">
                <div className="minimal-card-header">
                  <Clock size={14} />
                  <span>Extension of Time</span>
                </div>
                <div className="minimal-stats">
                  {eotRows.map((row, idx) => {
                    const Icon = row.icon;
                    return (
                      <div key={idx} className="minimal-stat">
                        <Icon size={14} />
                        <div>
                          <span className="minimal-stat-label">{row.label}</span>
                          <span className="minimal-stat-value">{row.value || "0"}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="minimal-card half">
                <div className="minimal-card-header">
                  <Award size={14} />
                  <span>Change of Scope</span>
                </div>
                <div className="minimal-stats">
                  {cosRows.map((row, idx) => {
                    const Icon = row.icon;
                    return (
                      <div key={idx} className="minimal-stat">
                        <Icon size={14} />
                        <div>
                          <span className="minimal-stat-label">{row.label}</span>
                          <span className="minimal-stat-value">{row.value || "0"}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Timeline */}
            <div className="minimal-card">
              <div className="minimal-card-header">
                <Calendar size={14} />
                <span>Project Timeline</span>
              </div>
              <div className="minimal-timeline">
                {dateRows.map((row, idx) => {
                  const Icon = row.icon;
                  return (
                    <div key={idx} className="minimal-timeline-item">
                      <div className="minimal-timeline-icon">
                        <Icon size={12} />
                      </div>
                      <div className="minimal-timeline-label">{row.label}</div>
                      <div className="minimal-timeline-value">{row.value || "-"}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};


// const BillTable = ({ projectName, projectId, contractor, contractorlist, site_prcode, contractor_name, contractorAmount, costwithCOS }) => {


//   const role = sessionStorage.getItem('sitemanagement_role');

//   const [buffer, setBuffering] = useState(false); //buffering logic
//   const [bills, setBills] = useState([]);
//   const getProjectBillDetails = async () => {
//     setBuffering(true); //buffering logic // Start Buffering 
//     try {
//       const bill = await axios.get(
//         `${BASE_URL}/siteproject/billingbycontractor/${contractor}/`
//       );
//       const sortedData = bill.data.sort(
//         (a, b) => new Date(b.submitted_bill_date) - new Date(a.submitted_bill_date)
//       );
//       setBills(sortedData);




//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false); //buffering logic // End Buffering
//     }
//   };

//   useEffect(() => {
//     getProjectBillDetails();

//   }, [contractor]);


//   const [cosData, setCodData] = useState([]);

//   const getCOSData = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/cosfilter/${projectId}/contractor/${contractor}/Approved/`)
//       setCodData(res.data);
//     } catch (error) {
//       alert("Error fetching COS data", error);
//       console.error(error);

//     }

//   };


//   useEffect(() => {
//     if (projectId && contractor) {
//       getCOSData();
//     }
//   }, [projectId, contractor])

//   return (

//     <div className="info-box-div-bg attendance-history-cont" style={{ margin: "0px" }}>

//       <div className="jd-heading-outer-flex ">
//         <h2 className="jd-heading-main font-weight600  font-size-heading">Contractor Bills</h2>
//         {
//           contractor === undefined ? <></>
//             :
//             <>
//               {role !== "ViewAccess" &&
//                 <div className="field-cont">
//                   <AddProjectBill project={projectId} cosData={cosData} getProjects={getProjectBillDetails} contractor={contractor} contractorlist={contractorlist} site_prcode={site_prcode} projectName={projectName} />
//                   {role === "Admin" && <UploadBillingBulk projectId={projectId} getBilling={getProjectBillDetails} contractor={contractor} site_prcode={site_prcode} contractor_name={contractor_name} workperformedby={"contractor"} />}
//                 </div>
//               }

//             </>
//         }

//       </div>
//       <div>
//         <div className="jd-heading-bottom-bold"></div>
//         <div className="jd-heading-bottom-light"></div>
//       </div>

//       <div className='table-box height-40vh paddingTop-0px scroll-container-table child-table-scroll '>


//         <table className="table-css">
//           <thead className='table-heading'>
//             <tr className="custom-table-head-tr">
//               <th className="table-heading-text text-lefttt">S.No.</th>
//               <th className="table-heading-text">Period</th>
//               <th className="table-heading-text ">Bill Details</th>
//               <th className="table-heading-text text-start ">Submited Details</th>
//               <th className="table-heading-text text-start">AE/IE Recommended Details</th>

//               <th className="table-heading-text text-start">Client Approved Details</th>
//               {role !== "VieAccess" &&
//                 <th className="table-heading-text text-center">Action</th>
//               }
//             </tr>
//           </thead>
//           {buffer ? (
//             <div className="spinner-smalll"></div>
//           ) : (
//             <tbody>
//               {bills
//                 .map((billData, monthIndex) => (
//                   <tr className="custom-table-head-td" key={monthIndex}>

//                     <td className="table-body text-lefttt">{`${monthIndex + 1} .`}</td>
//                     <td className="table-body text-center">{formatDateDD_MM_YYYY(billData.bill_period_start)}<br />To  <br />{formatDateDD_MM_YYYY(billData.bill_period_end)}</td>

//                     <td className="table-body">
//                       <tr>
//                         <td className="padding-bottom-5px">Number</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.bill_num}</td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">Type</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.bill_type}</td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">Catergory</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.bill_catagory}</td>
//                       </tr>
//                     </td>

//                     <td className="table-body ">
//                       <tr>
//                         <td className="padding-bottom-5px">Date</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.submitted_bill_date === null ?
//                           <td className="text-end">-</td>
//                           :
//                           <td className="text-end">{formatDateDD_MM_YYYY(billData.submitted_bill_date)}</td>
//                         }</td>
//                       </tr>
//                       <tr>

//                         <td className="padding-bottom-5px">
//                           Amount
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">₹{formatCurrencyIndian(billData.submitted_bill_amount ? billData.submitted_bill_amount : "0")}</td>

//                       </tr>

//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Percentage
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.submitted_percentage}%</td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Percentage Amount
//                         </td>

//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">₹{formatCurrencyIndian(billData.percentage_amt ? billData.percentage_amt : "0")}</td>
//                       </tr>
//                       <tr>

//                         <td className="padding-bottom-5px">
//                           Amount Summary
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className='text-center' ><ViewAmountModel usedIn="nestedTable" usedFor="ContractorBilling" i={billData} bills={bills} /></td>

//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Submitted Letter
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-center" >
//                           {/* <AssociatedLetters id={billData.submitted_letter_num} /> */}
//                           {/* <UpdateTrackRecordDetailwithIDonly
//                             i={billData.submitted_letter_num}
//                             projectId={projectId} /> */}
//                           <ViewLetterModal i={billData.submitted_letter_num} usedFor="nestedTable" />
//                         </td>
//                       </tr>

//                     </td>
//                     <td className="table-body ">
//                       <td className="table-body ">
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Date
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>

//                           <td className="text-end">{billData.recomended_bill_date === null ?
//                             <td className="text-end">-</td>
//                             :
//                             <td className="text-end">{formatDateDD_MM_YYYY(billData.recomended_bill_date)}</td>
//                           }</td>

//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Amount
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">₹{formatCurrencyIndian(billData.recommended_bill_amount ? billData.recommended_bill_amount : "0")}</td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Percentage
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">{billData.recommended_percentage}%</td>



//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Percentage Amount
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">₹{formatCurrencyIndian(billData.ho_percentage_amt ? billData.ho_percentage_amt : "0")}</td>

//                         </tr>
//                         <tr>

//                           <td className="padding-bottom-5px">
//                             Amount Summary
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className='text-center'><ViewAmountModel usedIn="nestedTable" usedFor="HO" i={billData} bills={bills} /></td>

//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Recommended Letter
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-center">
//                             <ViewLetterModal i={billData.recomended_letter_num} usedFor="nestedTable" />
//                           </td>
//                         </tr>
//                         {billData.ho_attachment ?
//                           <tr>
//                             <td className="padding-bottom-5px">
//                               HO Attachment
//                             </td>
//                             <td style={{ padding: "0px 4px" }}>:</td>
//                             <td className="text-end">
//                               <a href={billData.ho_attachment} target="blank" style={{ fontSize: "15px" }}>
//                                 View
//                               </a>
//                             </td>
//                           </tr> : ""
//                         }
//                       </td>
//                     </td>
//                     <td className="table-body ">
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Date
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         {billData.site_recomended_bill_date === null ?
//                           <td className="text-end">-</td>
//                           :
//                           <td className="text-end">{formatDateDD_MM_YYYY(billData.site_recomended_bill_date)}</td>
//                         }
//                       </tr>

//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Amount
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">₹{formatCurrencyIndian(billData.site_recommended_bill_amount ? billData.site_recommended_bill_amount : "0")}</td>

//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Percentage
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">{billData.site_recommended_percentage}%</td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Percentage Amount
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">₹{formatCurrencyIndian(billData.site_percentage_amt ? billData.site_percentage_amt : "0")}</td>

//                       </tr>
//                       <tr>

//                         <td className="padding-bottom-5px">
//                           Amount Summary
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className='text-center'><ViewAmountModel usedIn="nestedTable" usedFor="SiteBilling" i={billData} bills={bills} /></td>

//                       </tr>
//                       <tr>

//                         <td className="padding-bottom-5px">
//                           Client Attachment
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className='text-end view-text'> <a href={billData.ho_attachment} target="blank" style={{ fontSize: "15px" }}>
//                           View
//                         </a></td>

//                       </tr>
//                     </td>








//                     {role !== "ViewAccess" && (
//                       <>
//                         {role !== "Admin" ? (
//                           isEditable(billData.created_at) ? (
//                             <td className="table-body width-5vw">
//                               <div className="flex-row justify-center">
//                                 {billData.lock === false && (
//                                   <UpdateBill
//                                     i={billData}
//                                     project={projectId}
//                                     getProjects={getProjectBillDetails}
//                                     cosData={cosData}
//                                   />
//                                 )}

//                                 {role === "Admin" && (
//                                   <Lock
//                                     apiName="billingdetailfield"
//                                     id={billData.id}
//                                     i={billData}
//                                     usedFor="Contractor Bill"
//                                     getData={getProjectBillDetails}
//                                   />
//                                 )}

//                                 {(role !== "Account" && role !== "SiteManagement") &&
//                                   billData.lock === false && (
//                                     <DeleteBillingDetails
//                                       i={billData}
//                                       getbillingDetail={getProjectBillDetails}
//                                     />
//                                   )}
//                               </div>
//                             </td>
//                           ) : (
//                             <td className="table-body width-5vw text-center">-</td>
//                           )
//                         ) : (
//                           <td className="table-body width-5vw">
//                             <div className="flex-row justify-center">
//                               {billData.lock === false && (
//                                 <UpdateBill
//                                   i={billData}
//                                   cosData={cosData}
//                                   project={projectId}
//                                   getProjects={getProjectBillDetails}
//                                 />
//                               )}

//                               {role === "Admin" && (
//                                 <Lock
//                                   apiName="billingdetailfield"
//                                   id={billData.id}
//                                   i={billData}
//                                   usedFor="Contractor Bill"
//                                   getData={getProjectBillDetails}
//                                 />
//                               )}

//                               {(role !== "Account" && role !== "SiteManagement") &&
//                                 billData.lock === false && (
//                                   <DeleteBillingDetails
//                                     i={billData}
//                                     getbillingDetail={getProjectBillDetails}
//                                   />
//                                 )}
//                             </div>
//                           </td>
//                         )}
//                       </>
//                     )}






//                   </tr>
//                 ))}
//             </tbody>
//           )}
//         </table>


//       </div>

//     </div>
//   );
// }

const BillTable = ({ projectName, projectId, contractor, contractorlist, site_prcode, contractor_name, contractorAmount, costwithCOS }) => {
  const role = sessionStorage.getItem('sitemanagement_role');
  const [buffer, setBuffering] = useState(false);
  const [bills, setBills] = useState([]);

  const getProjectBillDetails = async () => {
    setBuffering(true);
    try {
      const bill = await axios.get(`${BASE_URL}/siteproject/billingbycontractor/${contractor}/`);
      const sortedData = bill.data.sort(
        (a, b) => new Date(b.submitted_bill_date) - new Date(a.submitted_bill_date)
      );
      setBills(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getProjectBillDetails();
  }, [contractor]);

  const [cosData, setCodData] = useState([]);

  const getCOSData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/cosfilter/${projectId}/contractor/${contractor}/Approved/`);
      setCodData(res.data);
    } catch (error) {
      console.error("Error fetching COS data", error);
    }
  };

  useEffect(() => {
    if (projectId && contractor) {
      getCOSData();
    }
  }, [projectId, contractor]);

  // Calculate summary stats
  const totalBills = bills.length;
  const totalSubmittedAmount = bills.reduce((sum, b) => sum + (parseFloat(b.submitted_bill_amount) || 0), 0);
  const totalRecommendedAmount = bills.reduce((sum, b) => sum + (parseFloat(b.recommended_bill_amount) || 0), 0);
  const totalApprovedAmount = bills.reduce((sum, b) => sum + (parseFloat(b.site_recommended_bill_amount) || 0), 0);

  return (
    <div className="progress-modern-container">
      {/* Header */}
      <div className="progress-header-minimal">
        <div className="header-left">
          <div className="header-icon">
            <FileText size={18} />
          </div>
          <div>
            <h3 className="header-title">Contractor Bills</h3>
            <p className="header-subtitle">{contractor_name || "Contractor"} • {projectName || "Project"}</p>
          </div>
        </div>
        {contractor !== undefined && role !== "ViewAccess" && (
          <div className="header-actions">
            <AddProjectBill
              project={projectId}
              cosData={cosData}
              getProjects={getProjectBillDetails}
              contractor={contractor}
              contractorlist={contractorlist}
              site_prcode={site_prcode}
              projectName={projectName}
            />
            {role === "Admin" && (
              <UploadBillingBulk
                projectId={projectId}
                getBilling={getProjectBillDetails}
                contractor={contractor}
                site_prcode={site_prcode}
                contractor_name={contractor_name}
                workperformedby={"contractor"}
              />
            )}
          </div>
        )}
      </div>


      <div className="table-wrapper-minimal table-box scroll-container-table">
        {buffer ? (
          <div className="loader-minimal">
            <div className="spinner-minimal"></div>
          </div>
        ) : (
          <table className="bill-table-modern">
            <thead>
              <tr className="bill-table-header">
                <th className="col-sno">#</th>
                <th className="col-period" style={{ textAlign: "center" }}>Period</th>
                <th className="col-bill-details">Bill Details</th>
                <th className="col-submitted text-center" >Submitted</th>
                <th className="col-recommended text-center">AE/IE Recommended</th>
                <th className="col-approved text-center">Client Approved</th>
                {role !== "ViewAccess" && <th className="col-action text-center">Action</th>}
              </tr>
            </thead>
            <tbody>
              {bills.map((billData, index) => (
                <tr className="bill-table-row" key={index}>
                  <td className="col-sno">{index + 1}</td>

                  <td className="col-period">
                    <div className="period-cell">
                      <Calendar size={12} />
                      <span>{formatDateDD_MM_YYYY(billData.bill_period_start)}<br />to<br />{formatDateDD_MM_YYYY(billData.bill_period_end)}</span>
                    </div>
                  </td>

                  <td className="col-bill-details">
                    <div className="bill-details-cell">
                      <div className="detail-item" style={{ textAlign: "start" }}>
                        <span className="detail-label">Number:</span>
                        <span className="detail-value">{billData.bill_num}</span>
                      </div>
                      <div className="detail-item" style={{ textAlign: "start" }}>
                        <span className="detail-label">Type:</span>
                        <span className="detail-value">{billData.bill_type}</span>
                      </div>
                      <div className="detail-item" style={{ textAlign: "start" }}>
                        <span className="detail-label">Category:</span>
                        <span className="detail-value">{billData.bill_catagory}</span>
                      </div>
                    </div>
                  </td>

                  <td className="col-submitted">
                    <div className="stage-card submitted">
                      <div className="stage-header">
                        <FileText size={12} />
                        <span>Submitted</span>
                      </div>
                      <div className="stage-content">
                        <div className="stage-row">
                          <span className="stage-label">Date:</span>
                          <span>{billData.submitted_bill_date ? formatDateDD_MM_YYYY(billData.submitted_bill_date) : '-'}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Amount:</span>
                          <span className="amount">₹{formatCurrencyIndian(billData.submitted_bill_amount || 0)}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Percentage:</span>
                          <span>{billData.submitted_percentage}%</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Per. Amount:</span>
                          <span>₹{formatCurrencyIndian(billData.percentage_amt || 0)}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Summary:</span>
                          <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="ContractorBilling" i={billData} bills={bills} />
                        </div>
                        {billData.submitted_letter_num && (
                          <div className="stage-row">
                            <span className="stage-label">Letter:</span>
                            <ViewLetterModal modernCSS="true" i={billData.submitted_letter_num} usedFor="nestedTable" />
                          </div>
                        )}
                      </div>
                    </div>
                  </td>

                  <td className="col-recommended">
                    <div className="stage-card recommended">
                      <div className="stage-header">
                        <CheckCircle size={12} />
                        <span>AE/IE Recommended</span>
                      </div>
                      <div className="stage-content">
                        <div className="stage-row">
                          <span className="stage-label">Date:</span>
                          <span>{billData.recomended_bill_date ? formatDateDD_MM_YYYY(billData.recomended_bill_date) : '-'}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Amount:</span>
                          <span className="amount">₹{formatCurrencyIndian(billData.recommended_bill_amount || 0)}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Percentage:</span>
                          <span>{billData.recommended_percentage}%</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Per. Amount:</span>
                          <span>₹{formatCurrencyIndian(billData.ho_percentage_amt || 0)}</span>
                        </div>
                        <div className="stage-row" >
                          <span className="stage-label">Summary:</span>
                          <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="HO" i={billData} bills={bills} />
                        </div>
                        {billData.recomended_letter_num && (
                          <div className="stage-row">
                            <span className="stage-label">Letter:</span>

                            <ViewLetterModal modernCSS="true" i={billData.recomended_letter_num} usedFor="nestedTable" />

                          </div>
                        )}
                        {billData.ho_attachment && (
                          <div className="stage-row">
                            <span className="stage-label">Attachment:</span>
                            <a href={billData.ho_attachment} target="blank" className="attachment-link">View</a>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>

                  <td className="col-approved">
                    <div className="stage-card approved">
                      <div className="stage-header">
                        <Award size={12} />
                        <span>Client Approved</span>
                      </div>
                      <div className="stage-content">
                        <div className="stage-row">
                          <span className="stage-label">Date:</span>
                          <span>{billData.site_recomended_bill_date ? formatDateDD_MM_YYYY(billData.site_recomended_bill_date) : '-'}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Amount:</span>
                          <span className="amount">₹{formatCurrencyIndian(billData.site_recommended_bill_amount || 0)}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Percentage:</span>
                          <span>{billData.site_recommended_percentage}%</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Per. Amount:</span>
                          <span>₹{formatCurrencyIndian(billData.site_percentage_amt || 0)}</span>
                        </div>
                        <div className="stage-row">
                          <span className="stage-label">Summary:</span>
                          <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="SiteBilling" i={billData} bills={bills} />
                        </div>
                        {billData.ho_attachment && (
                          <div className="stage-row">
                            <span className="stage-label">Attachment:</span>
                            <a href={billData.ho_attachment} target="blank" className="attachment-link">View</a>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>

                  {role !== "ViewAccess" && (
                    <td className="col-action">
                      <div className="action-group-minimal">
                        {(role === "Admin" || isEditable(billData.created_at)) && billData.lock === false && (
                          <UpdateBill
                            i={billData}
                            project={projectId}
                            getProjects={getProjectBillDetails}
                            cosData={cosData}
                          />
                        )}
                        {role === "Admin" && (
                          <Lock
                            apiName="billingdetailfield"
                            id={billData.id}
                            i={billData}
                            usedFor="Contractor Bill"
                            getData={getProjectBillDetails}
                          />
                        )}
                        {(role !== "Account" && role !== "SiteManagement") && billData.lock === false && (
                          <DeleteBillingDetails
                            i={billData}
                            getbillingDetail={getProjectBillDetails}
                          />
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};


const BillingDetailsTable = ({ projectId, contractor, contractor_name, contractorAmount, costwithCOS }) => {
  const [buffer, setBuffering] = useState(false);
  const [billingDetails, setBillingData] = useState([]);
  const ref = useRef();

  console.log(contractor_name)
  console.log("contractor_name")

  const getProjectBillDetails = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/billingbycontractor/${contractor}/`
      );

      // Sort by date (assuming 'billing_date' exists and is in a sortable format)
      const sortedData = response.data.sort(
        (a, b) => new Date(b.bill_period_start) - new Date(a.bill_period_start)
      );

      setBillingData(sortedData);
    } catch (err) {
      console.error("Error fetching billing details:", err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getProjectBillDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractor]);

  const formattedDateLong = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const renderBillsAndBalanceBills = (contractorData) => {


    // Handle cases when only one of bill or balancebill exists
    const maxLength = Math.max(contractorData.length);
    const rows = [];

    for (let i = 0; i < maxLength; i++) {
      const billDetails = contractorData;


      rows.push(
        <tr key={i}>
          <td>Bill No.</td>
          <td>{`${billDetails.bill_type || ""}-${billDetails.bill_num || ""} (${billDetails.submitted_percentage || ""}%), Letter No. ${billDetails.submittedletter_number || "-"}`}</td>
          <td>{`${billDetails.bill_type || ""}-${billDetails.bill_num || ""} (${billDetails.recommended_percentage || ""}%), Letter No. ${billDetails.recomendedletter_number || "-"}`}</td>
        </tr>,
        <tr key={`date-${i}`}>
          <td>Bill Date</td>
          <td>{formattedDateLong(billDetails.submitted_bill_date) || "-"}</td>
          <td>{formattedDateLong(billDetails.recomended_bill_date) || "-"}</td>
        </tr>,
        <tr key={`period-${i}`}>
          <td>Bill Period</td>
          <td>
            {billDetails.bill_period_start && billDetails.bill_period_end
              ? `${formattedDateLong(billDetails.bill_period_start)} - ${formattedDateLong(billDetails.bill_period_end)}`
              : "-"}
          </td>
          <td>
            {billDetails.bill_period_start && billDetails.bill_period_end
              ? `${formattedDateLong(billDetails.bill_period_start)} - ${formattedDateLong(billDetails.bill_period_end)}`
              : "-"}
          </td>

        </tr>,
        <tr key={`amount-${i}`}>
          <td>Bill Amt.</td>
          <td>{formatRoundoffCrores(billDetails.submitted_bill_amount || "-")}</td>
          <td>{formatRoundoffCrores(billDetails.recommended_bill_amount || "-")}</td>
        </tr>,

        <tr key={`amount-${i}`}>
          <td>Withheld Amt.</td>
          <td>{formatCurrencyIndian(billDetails.withheld_amt || "-")}</td>
          <td>{"-"}</td>
          <td>{"-"}</td>
        </tr>,
        <tr key={`amount-${i}`}>
          <td>Released withheld Amt</td>
          <td>{"-"}</td>
          <td>{formatCurrencyIndian(billDetails.released_withheld_amt || "-")}</td>
          <td>{"-"}</td>
        </tr>,
        <tr key={`amount-${i}`}>
          <td>LD Amt</td>
          <td>{"-"}</td>
          <td>{formatCurrencyIndian(billDetails.ld_amount || "-")}</td>
          <td>{"-"}</td>
        </tr>
        ,
        <tr key={`amount-${i}`}>
          <td>Deduction Amt</td>
          <td>{formatCurrencyIndian(billDetails.deduction_amount || "-")}</td>
          <td>{"-"}</td>
          <td>{"-"}</td>
        </tr>

      );
    }
    return rows;
  };

  const filteredData = Object.values(
    billingDetails.reduce((acc, curr) => {
      if (curr.bill_catagory !== "bills") return acc;

      const existing = acc[curr.bill_period_start];

      if (!existing) {
        acc[curr.bill_period_start] = curr;
      } else if (curr.bill_type === "sps" && existing.bill_type !== "sps") {
        // prefer sps over ipc when both are "bills"
        acc[curr.bill_period_start] = curr;
      }

      return acc;
    }, {})
  )

  const total_amount = filteredData.reduce(
    (acc, item) => acc + Number(item.site_work_done_amt || 0),
    0
  );


  return (
    <div ref={ref} className="info-box-div-bg">
      <div className="heading-bg-color-white">
        <div className="jd-heading-outer-flex ">
          <h2 className="jd-heading-main font-weight600 font-size-heading">Contractor Billing Data</h2>

          <div className="field-cont">
            <div>
              <h6 style={{ color: "green" }}>Contractor Amount:
                <span style={{ textAlign: "end" }}>
                  {formatCurrencyIndian(costwithCOS ? costwithCOS : contractorAmount)}
                </span>
              </h6>
              <h6 style={{ color: "darkgreen" }}>Total Billing Amount:
                <span style={{ textAlign: "end" }}>
                  {formatCurrencyIndian(Number(total_amount).toFixed(0))}
                </span>
              </h6>
              <h6 style={{ color: "red" }}>Remaining Amount:
                <span style={{ textAlign: "end" }}>
                  {formatCurrencyIndian(Number(costwithCOS ? Number(costwithCOS).toFixed(0) : Number(contractorAmount).toFixed(0)) - Number(total_amount).toFixed(0))}
                </span>
              </h6>

            </div>
            {sessionStorage.getItem('sitemanagement_role') !== "ViewAccess" &&
              <ReactToPrint
                bodyClass="print-agreement"
                content={() => ref.current}
                trigger={() => (
                  <button className="model-button model-button-black hide-on-print" style={{ backgroundColor: '#2576bc', color: 'white', border: '1px solid #2576bc' }}>


                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 18" fill="none">
                      <path d="M17 5H3C1.34 5 0 6.34 0 8V12C0 13.1 0.9 14 2 14H4V16C4 17.1 4.9 18 6 18H14C15.1 18 16 17.1 16 16V14H18C19.1 14 20 13.1 20 12V8C20 6.34 18.66 5 17 5ZM13 16H7C6.45 16 6 15.55 6 15V11H14V15C14 15.55 13.55 16 13 16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM15 0H5C4.45 0 4 0.45 4 1V3C4 3.55 4.45 4 5 4H15C15.55 4 16 3.55 16 3V1C16 0.45 15.55 0 15 0Z" fill="white" />
                    </svg>
                    Print
                  </button>
                )}
              />
            }

          </div>
        </div >
        <div>
          <div className="jd-heading-bottom-bold"></div>
          <div className="jd-heading-bottom-light"></div>
        </div>
      </div >

      <div  >
        <table className="nested-table-lightblue">
          <thead >
            <tr className="custom-table-head-tr ">
              <th className="table-heading-text" rowSpan="4">S.No.</th>
              <th className="table-heading-text" rowSpan="4">Bill Period</th>
              <th className="table-heading-text " rowSpan="4">Contractor</th>
              <th className="table-heading-text text-center" colSpan="6">Details</th>
            </tr>
            <tr>
              <th rowSpan="2">Bill Details</th>
              <th colSpan="6">Amount Details</th>
            </tr>
            <tr>
              <th rowSpan="2">Contractor Submission</th>
              <th>Recommended by AE/IE</th>
              <th >Approved by Client</th>
            </tr>

          </thead>
          <tbody>
            {billingDetails?.length > 0 ? <>
              {billingDetails.map((i, index) => (
                <tr>
                  <td>
                    {index + 1}.
                  </td>
                  <td>
                    from: {formatDateDD_MM_YYYY(i.bill_period_start)}<br />
                    to:{formatDateDD_MM_YYYY(i.bill_period_end)}
                  </td>
                  <td>
                    {contractor_name}
                  </td>
                  <td>
                    <tbody className='nested-table-lightblue '>
                      <tr>
                        <td>Bill Number</td>
                        <td>{i.bill_num}</td>
                      </tr>
                      <tr>
                        <td>Bill Type</td>
                        <td>{i.bill_type}</td>
                      </tr>
                      <tr>
                        <td>Bill Category</td>
                        <td>{i.bill_catagory}</td>
                      </tr>
                    </tbody>
                  </td>
                  <td>
                    <ViewAmountModel usedIn="nestedTable" usedFor="ContractorBilling" i={i} bills={billingDetails} ModuleName="Billing Details" />
                  </td>
                  <td>
                    <ViewAmountModel usedIn="nestedTable" usedFor="HO" i={i} bills={billingDetails} ModuleName="Billing Details" />

                  </td>
                  <td>
                    <ViewAmountModel usedIn="nestedTable" usedFor="SiteBilling" i={i} bills={billingDetails} ModuleName="Billing Details" />

                  </td>



                </tr>
              ))}
            </> :
              <tr>
                <td className='text-center' colSpan="7"><strong>No Billing Details Available</strong> </td>
              </tr>
            }
          </tbody>

        </table>
      </div>
    </div >
  );
};



// const EOTTable = ({ projectName, projectId, toggleState, contractor, contractorlist, site_prcode, contractor_name, contractor_updated_date, contractor_date, EOTDays, contractor_id, viewBy }) => {
//   const role = sessionStorage.getItem('sitemanagement_role');
//   const [eotList, setEotList] = useState([]);
//   const [eotStatus, seteotStatus] = useState("null");
//   const [buffer, setBuffer] = useState(false);

//   const getEot = async () => {

//     try {
//       setBuffer(true);
//       // let eot = await axios.get(`${BASE_URL}/siteproject/eot/`);
//       let eot = await axios.get(`${BASE_URL}/siteproject/eotfilter/${projectId}/${toggleState}/${contractor}/${eotStatus}/`);
//       setEotList(eot.data);


//     } catch (err) {
//       //toast Logic
//       handleErrorToast(err);
//     } finally {
//       setBuffer(false)
//     }
//   };
//   // Handle status change from the dropdown
//   const handleStatusChange = (event) => {
//     seteotStatus(event.target.value);
//   };





//   useEffect(() => {
//     getEot();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [contractor, projectId, toggleState, eotStatus]);



//   return (

//     <div className="info-box-div-bg ">
//       <div >
//         <div className="jd-heading-outer-flex ">
//           <h2 className="jd-heading-main font-weight600  font-size-heading">Extention of Time</h2>

//           {
//             contractor === undefined ?
//               <></>
//               :
//               <>
//                 <div className="field-cont">
//                   <select className='status-dropdown-all' value={eotStatus} onChange={handleStatusChange} style={{ borderColor: "#9ec2e1" }}>
//                     <option value='null'>All</option>
//                     <option value='pending'>Pending</option>
//                     <option value='Approved'>Approved</option>
//                     <option value='rejected'>Rejected</option>
//                   </select>
//                   {

//                     role !== "ViewAccess" &&
//                     <>

//                       <AddEOTDetails project={projectId} getEot={getEot} toggleState={toggleState} contractor={contractor} contractorlist={contractorlist} site_prcode={site_prcode}
//                         projectName={projectName} />
//                       {/* {role === "Admin" && <UploadEotBulk projectId={projectId} site_prcode={site_prcode} workperformedby={toggleState} contractor_name={contractor_name} getEotdata={getEot} />} */}
//                     </>
//                   }
//                 </div>
//               </>

//           }

//         </div>
//         <div>
//           <div className="jd-heading-bottom-bold"></div>
//           <div className="jd-heading-bottom-light"></div>
//         </div>
//       </div>

//       <div className="form-flex-wrap table-box paddingTop-0px  scroll-container-table child-table-scroll">

//         <table className="table-css">
//           <thead className='table-heading' style={{ zIndex: "999" }}>
//             <tr className="custom-table-head-tr " >
//               <th className="table-heading-text text-lefttt">S. No.</th>
//               <th className="table-heading-text">EOT Code</th>
//               <th className="table-heading-text text-center">EOT Dates</th>
//               <th className="table-heading-text">Days</th>
//               <th className="table-heading-text text-center">Letters</th>
//               <th className="table-heading-text">All Letter Trail</th>
//               <th className="table-heading-text text-center" >Status</th>
//               {role !== "ViewAccess" &&

//                 <th className="table-heading-text text-center ">Action</th>
//               }

//             </tr>
//           </thead>
//           {buffer ? <div className="spinner-smalll"></div> : null}
//           <tbody>
//             {eotList?.map((i, index) => (
//               <React.Fragment key={index}>

//                 <tr className="custom-table-head-td">
//                   <td className="table-body text-lefttt">{`${index + 1} .`}</td>
//                   <td className="table-body">{i.eot_code}</td>
//                   {i.process_initiate_date || i.approved_date ?
//                     <td className="table-body ">

//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Initial Submssion
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start" >
//                           {i.process_initiate_date ? formattedDateLong(i.process_initiate_date) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       {toggleState === "contractor" &&
//                         <>
//                           <tr>
//                             <td className="padding-bottom-5px table-body">AE/IE Response
//                             </td>
//                             <td style={{ padding: "0px 4px" }}>:</td>
//                             <td className="text-start">
//                               {i.ae_approved_date ? formattedDateLong(i.ae_approved_date) : <div className="text-center">-</div>}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="padding-bottom-5px table-body">AE/IE Observation
//                             </td>
//                             <td style={{ padding: "0px 4px" }}>:</td>
//                             <td className="text-start">
//                               {i.ae_ie_observation_date ? formattedDateLong(i.ae_ie_observation_date) : <div className="text-center">-</div>}
//                             </td>
//                           </tr>
//                           <tr>
//                             <td className="padding-bottom-5px table-body">AE/IE Rejected
//                             </td>
//                             <td style={{ padding: "0px 4px" }}>:</td>
//                             <td className="text-start">
//                               {i.ae_reject_date ? formattedDateLong(i.ae_reject_date) : <div className="text-center">-</div>}
//                             </td>
//                           </tr>

//                         </>
//                       }

//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Client Approved
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.approved_date ? formattedDateLong(i.approved_date) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Client Rejected
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.client_rejected_date ? formattedDateLong(i.client_rejected_date) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>

//                     </td> :
//                     <td className="table-body ">No Letters Attached</td>
//                   }
//                   {i.days || i.approved_days ?
//                     <td className="table-body ">

//                       <tr>
//                         <td className="padding-bottom-5px">
//                           For Approval
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end" >
//                           {i.days ? i.days : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       {toggleState === "contractor" &&
//                         <tr>
//                           <td className="padding-bottom-5px table-body">AE/IE Recommendation </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-start">
//                             <td className="text-start">
//                               {
//                                 i.ae_approved_days
//                                   ? i.ae_approved_days
//                                   : <div className="text-center">-</div>}
//                             </td>


//                           </td>

//                         </tr>
//                       }
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Approved
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end">
//                           {i.approved_days ? i.approved_days : <div className="text-center">-</div>}
//                         </td>
//                       </tr>

//                     </td>
//                     :
//                     <td className="table-body ">No Letters Attached</td>
//                   }
//                   <td className='table-body'>

//                     <tr>
//                       <td className="padding-bottom-5px">
//                         Initial
//                       </td>
//                       <td style={{ padding: "0px 4px" }}>:</td>
//                       <td className="text-end">
//                         {i.letter ? <AllAssociatedLetters buttonUI="normal" id={i.letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                       </td>
//                     </tr>
//                     {toggleState === "contractor" &&
//                       <>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             AE/IE Response
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">
//                             {i.ae_close_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_close_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             AE/IE Observation
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">
//                             {i.ae_ie_observation_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_ie_observation_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             AE/IE Rejected
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">
//                             {i.ae_ie_rejected_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_ie_rejected_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                           </td>
//                         </tr>
//                       </>
//                     }


//                     <tr>
//                       <td className="padding-bottom-5px">
//                         Client Approved
//                       </td>
//                       <td style={{ padding: "0px 4px" }}>:</td>
//                       <td className="text-end">
//                         {i.close_letter ? <AllAssociatedLetters buttonUI="normal" id={i.close_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="padding-bottom-5px">
//                         Client Rejected
//                       </td>
//                       <td style={{ padding: "0px 4px" }}>:</td>
//                       <td className="text-end">
//                         {i.client_rejected_letter ? <AllAssociatedLetters buttonUI="normal" id={i.client_rejected_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                       </td>
//                     </tr>
//                     <tr>
//                       <td className="padding-bottom-5px">
//                         Client Seek Clarification
//                       </td>
//                       <td style={{ padding: "0px 4px" }}>:</td>
//                       <td className="text-end">
//                         {i.client_seek_clarfication_letter ? <AllAssociatedLetters buttonUI="normal" id={i.client_seek_clarfication_letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" /> : "No letter attached"}

//                       </td>
//                     </tr>

//                   </td>
//                   {i.letter || i.close_letter ?
//                     <td className="table-body ">
//                       <AllAssociatedLetters id={i.letter} project={i.project} workperformedby={i.workperformedby} lettertype="eot" />
//                     </td> :
//                     <td className="table-body ">No Letters Attached</td>
//                   }


//                   <td className="table-body" style={{ textTransform: "capitalize" }}>
//                     <tr className='text-center'>
//                       <td className="padding-bottom-5px table-body text-start">-</td>
//                       <td style={{ padding: "0px 4px" }}>-</td>
//                       <td className="padding-bottom-5px table-body text-end">-</td>

//                     </tr>
//                     {toggleState === "contractor" &&
//                       <tr>
//                         <td className="padding-bottom-5px table-body">AE/IE Response Status</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.ae_eot_status ? i.ae_eot_status === "Approved" ? "Recommended" : i.ae_eot_status : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                     }
//                     <tr>
//                       <td className="padding-bottom-5px table-body">Client Response Status</td>
//                       <td style={{ padding: "0px 4px" }}>:</td>
//                       <td className="text-start">
//                         {i.eot_status ? i.eot_status : <div className="text-center">-</div>}
//                       </td>
//                     </tr>


//                   </td>

//                   {role !== "ViewAccess" &&
//                     <td className="table-body justify-center flex-row " >
//                       {
//                         i.lock === false &&

//                         <UpdateEOTDetails i={i} getEot={getEot} project={projectId} contractor={contractor} toggleState={toggleState} contractor_date={contractor_date} contractor_Updated_date={contractor_updated_date} EOTDays={EOTDays} contractor_id={contractor_id} eot_status={i.eot_status} approvedDays={i.approved_days} site_prcode={site_prcode}
//                           projectName={projectName} />
//                       }
//                       {role === "Admin" &&
//                         <Lock apiName="eot" id={i.id} i={i} usedFor="EOT" getData={getEot} />
//                       }
//                       {role === "SiteManagement" ? "" :
//                         <>
//                           {
//                             i.lock === false &&

//                             <DeleteEOT i={i} getEOT={getEot} contractor={contractor} toggleState={toggleState} />
//                           }
//                         </>
//                       }

//                     </td>
//                   }

//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>

//       </div >


//     </div >
//   )


// }

const EOTTable = ({ projectName, projectId, toggleState, contractor, contractorlist, site_prcode, contractor_name, contractor_updated_date, contractor_date, EOTDays, contractor_id, viewBy }) => {
  const role = sessionStorage.getItem('sitemanagement_role');
  const [eotList, setEotList] = useState([]);
  const [eotStatus, seteotStatus] = useState("null");
  const [buffer, setBuffer] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  const getEot = async () => {
    try {
      setBuffer(true);
      let eot = await axios.get(`${BASE_URL}/siteproject/eotfilter/${projectId}/${toggleState}/${contractor}/${eotStatus}/`);
      setEotList(eot.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffer(false);
    }
  };

  const handleStatusChange = (event) => {
    seteotStatus(event.target.value);
  };

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const getStatusColor = (status) => {
    if (status === 'Approved') return 'approved';
    if (status === 'rejected') return 'rejected';
    if (status === 'Recommended') return 'recommended';
    return 'pending';
  };

  const getStatusText = (status) => {
    if (status === 'Approved') return 'Approved';
    if (status === 'rejected') return 'Rejected';
    if (status === 'Recommended') return 'Recommended';
    return 'Pending';
  };

  useEffect(() => {
    getEot();
  }, [contractor, projectId, toggleState, eotStatus]);

  // Calculate stats
  const approvedCount = eotList.filter(e => e.eot_status === 'Approved').length;
  const rejectedCount = eotList.filter(e => e.eot_status === 'rejected').length;
  const pendingCount = eotList.filter(e => e.eot_status !== 'Approved' && e.eot_status !== 'rejected').length;

  return (
    <div className="progress-modern-container">
      {/* Header */}
      <div className="progress-header-minimal">
        <div className="header-left">
          <div className="header-icon">
            <Clock size={18} />
          </div>
          <div>
            <h3 className="header-title">Extension of Time</h3>
            <p className="header-subtitle">{contractor_name || "Contractor"} • {projectName || "Project"}</p>
          </div>
        </div>
        <div className="header-actions">
          <select className="status-filter-dropdown" value={eotStatus} onChange={handleStatusChange}>
            <option value='null'>All Status</option>
            <option value='pending'>Pending</option>
            <option value='Approved'>Approved</option>
            <option value='rejected'>Rejected</option>
          </select>
          {role !== "ViewAccess" && (
            <>
              <AddEOTDetails
                project={projectId}
                getEot={getEot}
                toggleState={toggleState}
                contractor={contractor}
                contractorlist={contractorlist}
                site_prcode={site_prcode}
                projectName={projectName}
              />
            </>
          )}
        </div>
      </div>

      {/* Stats Summary */}
      <div className="stats-minimal-row">
        <div className="stat-minimal-item">
          <Clock size={14} />
          <span>Total Requests</span>
          <strong>{eotList.length}</strong>
        </div>
        <div className="stat-minimal-item">
          <CheckCircle size={14} />
          <span>Approved</span>
          <strong>{approvedCount}</strong>
        </div>
        <div className="stat-minimal-item">
          <XCircle size={14} />
          <span>Rejected</span>
          <strong>{rejectedCount}</strong>
        </div>
        <div className="stat-minimal-item">
          <AlertCircle size={14} />
          <span>Pending</span>
          <strong>{pendingCount}</strong>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper-minimal">
        {buffer ? (
          <div className="loader-minimal">
            <div className="spinner-minimal"></div>
          </div>
        ) : (
          <table className="progress-table-minimal">
            <thead>
              <tr>
                <th className="col-sno">#</th>
                <th className="col-eot-code">EOT Code</th>
                <th className="col-dates">Dates</th>
                <th className="col-days">Days</th>
                <th className="col-status">Status</th>
                {role !== "ViewAccess" && <th className="col-action">Action</th>}
              </tr>
            </thead>
            <tbody>
              {eotList?.map((item, index) => {
                const isExpanded = expandedRow === index;
                const statusType = getStatusColor(item.eot_status);
                const isPending = statusType === 'pending';

                return (
                  <React.Fragment key={index}>
                    <tr className={`progress-row ${isPending ? 'has-pending' : ''}`}>
                      <td className="col-sno">{index + 1}</td>
                      <td className="col-eot-code">
                        <button className="period-trigger" onClick={() => toggleRow(index)}>
                          <FileText size={12} />
                          <span>{item.eot_code}</span>
                          {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                        </button>
                      </td>
                      <td className="col-dates">
                        <div className="dates-container">
                          {item.process_initiate_date && (
                            <div className="date-item">
                              <span className="date-label">Initial Submission:</span>
                              <span className="date-value">{formattedDateLong(item.process_initiate_date)}</span>
                            </div>
                          )}
                          {toggleState === "contractor" && item.ae_approved_date && (
                            <div className="date-item">
                              <span className="date-label">AE/IE Response:</span>
                              <span className="date-value">{formattedDateLong(item.ae_approved_date)}</span>
                            </div>
                          )}
                          {toggleState === "contractor" && item.ae_ie_observation_date && (
                            <div className="date-item">
                              <span className="date-label">AE/IE Observation:</span>
                              <span className="date-value">{formattedDateLong(item.ae_ie_observation_date)}</span>
                            </div>
                          )}
                          {item.approved_date && (
                            <div className="date-item">
                              <span className="date-label">Approved:</span>
                              <span className="date-value approved">{formattedDateLong(item.approved_date)}</span>
                            </div>
                          )}
                          {item.client_rejected_date && (
                            <div className="date-item">
                              <span className="date-label">Rejected:</span>
                              <span className="date-value rejected">{formattedDateLong(item.client_rejected_date)}</span>
                            </div>
                          )}
                          {!item.process_initiate_date && !item.approved_date && !item.client_rejected_date && (
                            <span className="no-letter">No dates available</span>
                          )}
                        </div>
                      </td>
                      <td className="col-days">
                        <div className="days-container">
                          {item.days && (
                            <div className="day-item">
                              <span className="day-label">Requested:</span>
                              <span className="day-value">{item.days} days</span>
                            </div>
                          )}
                          {toggleState === "contractor" && item.ae_approved_days && (
                            <div className="day-item">
                              <span className="day-label">AE/IE Rec.:</span>
                              <span className="day-value recommended">{item.ae_approved_days} days</span>
                            </div>
                          )}
                          {item.approved_days && (
                            <div className="day-item">
                              <span className="day-label">Approved:</span>
                              <span className="day-value approved">{item.approved_days} days</span>
                            </div>
                          )}
                          {!item.days && !item.approved_days && (
                            <span className="no-letter">No days recorded</span>
                          )}
                        </div>
                      </td>
                      <td className="col-status">
                        <span className={`status-badge-minimal ${statusType}`}>
                          {getStatusText(item.eot_status)}
                        </span>
                        {toggleState === "contractor" && item.ae_eot_status && (
                          <div className="sub-status">
                            <span className={`sub-status-badge ${item.ae_eot_status === "Approved" ? 'recommended' : ''}`}>
                              AE: {item.ae_eot_status === "Approved" ? "Recommended" : item.ae_eot_status}
                            </span>
                          </div>
                        )}
                      </td>
                      {role !== "ViewAccess" && (
                        <td className="col-action">
                          <div className="action-group-minimal">
                            {item.lock === false && (
                              <UpdateEOTDetails
                                i={item}
                                getEot={getEot}
                                project={projectId}
                                contractor={contractor}
                                toggleState={toggleState}
                                contractor_date={contractor_date}
                                contractor_Updated_date={contractor_updated_date}
                                EOTDays={EOTDays}
                                contractor_id={contractor_id}
                                eot_status={item.eot_status}
                                approvedDays={item.approved_days}
                                site_prcode={site_prcode}
                                projectName={projectName}
                              />
                            )}
                            {role === "Admin" && (
                              <Lock
                                apiName="eot"
                                id={item.id}
                                i={item}
                                usedFor="EOT"
                                getData={getEot}
                              />
                            )}
                            {item.lock === false && role !== "SiteManagement" && (
                              <DeleteEOT
                                i={item}
                                getEOT={getEot}
                                contractor={contractor}
                                toggleState={toggleState}
                              />
                            )}
                          </div>
                        </td>
                      )}
                    </tr>

                    {/* Expanded Row - Letters Section */}
                    {isExpanded && (
                      <tr className="expanded-row">
                        <td colSpan={role !== "ViewAccess" ? 6 : 5}>
                          <div className="expanded-content">
                            <div className="letters-section">
                              {/* Initial Letter */}
                              {item.letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <FileText size={14} />
                                    <span>Initial Submission Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {/* AE/IE Response Letter */}
                              {toggleState === "contractor" && item.ae_close_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <CheckCircle size={14} />
                                    <span>AE/IE Response Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.ae_close_letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {/* AE/IE Observation Letter */}
                              {toggleState === "contractor" && item.ae_ie_observation_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <AlertCircle size={14} />
                                    <span>AE/IE Observation Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.ae_ie_observation_letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {/* Client Approved Letter */}
                              {item.close_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <CheckCircle size={14} />
                                    <span>Client Approved Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.close_letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {/* Client Rejected Letter */}
                              {item.client_rejected_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <XCircle size={14} />
                                    <span>Client Rejected Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.client_rejected_letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {/* Client Seek Clarification Letter */}
                              {item.client_seek_clarfication_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <MessageCircle size={14} />
                                    <span>Client Seek Clarification</span>
                                  </div>
                                  <div className="letter-body">
                                    <AllAssociatedLetters
                                      buttonUI="normal"
                                      id={item.client_seek_clarfication_letter}
                                      project={item.project}
                                      workperformedby={item.workperformedby}
                                      lettertype="eot"
                                    />
                                  </div>
                                </div>
                              )}

                              {!item.letter && !item.close_letter && !item.ae_close_letter && (
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <FileText size={14} />
                                    <span>Letters</span>
                                  </div>
                                  <div className="letter-body">
                                    <span className="no-letter">No letters attached</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Empty State */}
      {!buffer && eotList.length === 0 && (
        <div className="empty-state">
          <Clock size={32} strokeOpacity={0.5} />
          <p>No EOT requests found</p>
        </div>
      )}
    </div>
  );
};

const COSTable = ({ projectName, projectId, toggleState, contractor, contractorlist, site_prcode, contractor_name, viewBy }) => {
  const [cosList, setCosList] = useState([]);
  const [buffer, setBuffering] = useState(false); //buffering logic
  const [loading, setLoading] = useState(false); //loading logic
  const [toggleShow, setToggleShow] = useState("null");
  const role = sessionStorage.getItem('sitemanagement_role');
  const [cosStatus, setCosStatus] = useState('null'); // Default to 'pending'


  const getCOS = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      let cos = await axios.get(`${BASE_URL}/siteproject/cosfilter/${projectId}/${toggleState}/${contractor}/${cosStatus}/`);
      setCosList(cos.data);


    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getCOS();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractor, cosStatus]);



  const handleStatusChange = (event) => {
    setCosStatus(event.target.value);
  };


  return (

    <div className="info-box-div-bg">
      <div >
        <div className="jd-heading-outer-flex ">
          <h2 className="jd-heading-main font-weight600  font-size-heading">Change of Scope</h2>
          <>

            {
              contractor === undefined ?
                <></>
                :
                <>
                  <div className="field-cont">
                    <select className='status-dropdown' value={cosStatus} onChange={handleStatusChange} style={{ borderColor: "#9ec2e1" }}>
                      <option value='null'>All</option>
                      <option value='pending'>Pending</option>
                      <option value='Approved'>Approved</option>
                      <option value='rejected'>Rejected</option>
                    </select>
                    {role !== "ViewAccess" &&
                      <>
                        <AddCOSDetails project={projectId} contractor={contractor} getProjects={getCOS} toggleState={toggleState} site_prcode={site_prcode} projectName={projectName} />
                        {/* {role === "Admin" && <UploadcosBulk projectId={projectId} getCOSData={getCOS} site_prcode={site_prcode} workperformedby={toggleState} contractor_name={contractor_name} />} */}

                      </>
                    }

                  </div>
                </>
            }

          </>
        </div>
        <div>
          <div className="jd-heading-bottom-bold"></div>
          <div className="jd-heading-bottom-light"></div>
        </div>
      </div>

      <div className="form-flex-wrap table-box paddingTop-0px scroll-container-table child-table-scroll">

        <table className="table-css">
          <thead className='table-heading' style={{ zIndex: "999" }}>
            <tr className="custom-table-head-tr" >
              <th className="table-heading-text text-lefttt">S. No.</th>
              <th className="table-heading-text">COS Code</th>
              <th className="table-heading-text">COS Type</th>
              <th className="table-heading-text text-center" >Status</th>

              <th className="table-heading-text text-center">COS Dates</th>
              <th className="table-heading-text text-center">Amount</th>
              <th className="table-heading-text text-center">Letters</th>
              <th className="table-heading-text tetx-center">All Letter Trail</th>
              {
                role !== "ViewAccess" &&
                <th className="table-heading-text text-center">Action</th>
              }

            </tr>
          </thead>
          {buffer ? <div className="spinner-smalll"></div> : null}
          <tbody>
            {cosList?.map((i, index) => (
              <React.Fragment key={index}>

                <tr className="custom-table-head-td">
                  <td className="table-body text-lefttt">{`${index + 1}`}</td>
                  <td className="table-body">{i.cos_code}</td>
                  <td className="table-body">{i.cos_type}</td>

                  <td className="table-body" style={{ textTransform: "capitalize" }}>

                    <tr>
                      <td className="padding-bottom-5px table-body">Client Response</td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        {i.cos_status ? i.cos_status : <div className="text-center">-</div>}
                      </td>
                    </tr>
                    {toggleState === "contractor" &&
                      <tr>
                        <td className="padding-bottom-5px table-body">AE/IE Response</td>
                        <td style={{ padding: "0px 4px" }}>:</td>
                        <td className="text-start">
                          {i.ae_cos_status ? i.ae_cos_status : <div className="text-center">-</div>}
                        </td>
                      </tr>
                    }

                  </td>
                  <td className="table-body text-center">
                    <tr>
                      <td className="padding-bottom-5px table-body">Initiate</td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        {i.process_initiate_date ? formattedDateLong(i.process_initiate_date) : <div className="text-center">-</div>}
                      </td>
                    </tr>
                    {toggleState === "contractor" &&
                      <>
                        <tr>
                          <td className="padding-bottom-5px table-body">AE/IE Recommended
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-start">
                            {i.ae_approval_date ? formattedDateLong(i.ae_approval_date) : i.ae_reject_date ? formattedDateLong(i.ae_reject_date) : <div className="text-center">-</div>}
                          </td>
                        </tr>


                        <tr>
                          <td className="padding-bottom-5px table-body">
                            AE/IE rejected
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-start">
                            {i.ae_ie_rejected_date ? formattedDateLong(i.ae_ie_rejected_date) : i.ae_reject_date ? formattedDateLong(i.ae_reject_date) : <div className="text-center">-</div>}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">
                            AE/IE observation
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-start">
                            {i.ae_ie_observation_date ? formattedDateLong(i.ae_ie_observation_date) : i.ae_reject_date ? formattedDateLong(i.ae_reject_date) : <div className="text-center">-</div>}
                          </td>
                        </tr>
                      </>
                    }

                    <tr>
                      <td className="padding-bottom-5px table-body">
                        Client In-principle
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        {i.client_in_principle_date ? formattedDateLong(i.client_in_principle_date) : <div className="text-center">-</div>}
                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px table-body">
                        Client Approved
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        {i.approval_date ? formattedDateLong(i.approval_date) : <div className="text-center">-</div>}
                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px table-body">
                        Client Rejected
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        {i.client_rejected_date ? formattedDateLong(i.client_rejected_date) : <div className="text-center">-</div>}
                      </td>
                    </tr>




                  </td>
                  <td className="table-body text-center">
                    <tr>
                      <td className="padding-bottom-5px table-body">{i.amount ? "Positive" : i.negativeamount ? "Negative" : "Initiate"}</td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        ₹{
                          i.amount
                            ? formatCurrencyIndian(parseFloat(i.amount).toFixed(0)) // Ensure it's a number first
                            : i.negativeamount
                              ? `-${formatCurrencyIndian(parseFloat(i.negativeamount).toFixed(0))}`
                              : <div className="text-center">-</div>
                        }
                      </td>


                    </tr>
                    {toggleState === "contractor" &&
                      <>
                        <tr>
                          <td className="padding-bottom-5px table-body">AE/IE Recommended</td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-start">
                            <td className="text-start">
                              {i.amount && i.ae_approved_amount
                                ? formatCurrencyIndian(parseFloat(i.ae_approved_amount).toFixed(0))
                                : i.negativeamount && i.ae_approved_amount
                                  ? `₹-${formatCurrencyIndian(parseFloat(i.ae_approved_amount).toFixed(0))}`
                                  : <div className="text-center">-</div>}
                            </td>


                          </td>

                        </tr>
                      </>

                    }
                    {toggleState === "contractor" &&
                      <>
                        <tr className='text-center'>
                          <td className="padding-bottom-5px table-body text-start">-</td>
                          <td style={{ padding: "0px 4px" }}>-</td>
                          <td className="padding-bottom-5px table-body text-end">-</td>

                        </tr>
                        <tr className='text-center'>
                          <td className="padding-bottom-5px table-body text-start">-</td>
                          <td style={{ padding: "0px 4px" }}>-</td>
                          <td className="padding-bottom-5px table-body text-end">-</td>

                        </tr>
                      </>
                    }

                    <tr style={{ marginTop: "10px" }}>
                      <td className="padding-bottom-5px table-body">Client In-Principle</td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        <td className="text-start">
                          {i.amount && i.in_principle_amount_byclient
                            ? formatCurrencyIndian(parseFloat(i.in_principle_amount_byclient).toFixed(0))
                            : i.negativeamount && i.in_principle_amount_byclient
                              ? `₹-${formatCurrencyIndian(parseFloat(i.in_principle_amount_byclient).toFixed(0))}`
                              : <div className="text-center">-</div>}
                        </td>


                      </td>

                    </tr>
                    <tr>
                      <td className="padding-bottom-5px table-body">Client Approved</td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-start">
                        <td className="text-start">
                          {i.amount && i.approved_amount
                            ? formatCurrencyIndian(parseFloat(i.approved_amount).toFixed(0))
                            : i.negativeamount && i.approved_amount
                              ? `₹-${formatCurrencyIndian(parseFloat(i.approved_amount).toFixed(0))}`
                              : <div className="text-center">-</div>}
                        </td>


                      </td>

                    </tr>
                    <tr className='text-center'>
                      <td className="padding-bottom-5px table-body"></td>
                      <td style={{ padding: "0px 4px" }}>-</td>
                    </tr>


                  </td>
                  <td className='table-body'>

                    <tr>
                      <td className="padding-bottom-5px">
                        Initial
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.letter ? <AllAssociatedLetters buttonUI="normal" id={i.letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                      </td>
                    </tr>
                    {toggleState === "contractor" &&
                      <>
                        <tr>
                          <td className="padding-bottom-5px">
                            AE/IE Recommended
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end">
                            {i.ae_close_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_close_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                          </td>
                        </tr>

                        <tr>
                          <td className="padding-bottom-5px">
                            AE/IE Rejected
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end">
                            {i.ae_ie_rejected_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_ie_rejected_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px">
                            AE/IE Observation
                          </td>
                          <td style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end">
                            {i.ae_ie_observation_letter ? <AllAssociatedLetters buttonUI="normal" id={i.ae_ie_observation_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                          </td>
                        </tr>
                      </>
                    }


                    <tr>
                      <td className="padding-bottom-5px">
                        Client In-Principle
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.client_in_principle_letter ? <AllAssociatedLetters buttonUI="normal" id={i.client_in_principle_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px">
                        Client Approved
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.close_letter ? <AllAssociatedLetters buttonUI="normal" id={i.close_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px">
                        Client Rejected
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.client_rejected_letter ? <AllAssociatedLetters buttonUI="normal" id={i.client_rejected_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px">
                        Client Seek Clarification
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.client_seek_clarfication_letter ? <AllAssociatedLetters buttonUI="normal" id={i.client_seek_clarfication_letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" /> : "No letter attached"}

                      </td>
                    </tr>

                  </td>
                  <td className="table-body">
                    {i.letter || i.close_letter ?
                      <td className="table-body ">

                        <AllAssociatedLetters id={i.letter} project={i.project} workperformedby={i.workperformedby} lettertype="cos" />
                      </td> :
                      <td className="table-body ">No Letters Attached</td>
                    }
                  </td>

                  {role !== "ViewAccess" &&
                    <td className="table-body flex-row justify-center" style={{ display: 'flex', gap: '5px' }}>

                      {
                        i.lock === false &&
                        <UpdateCOSDetails
                          toggleState={toggleState}
                          project={projectId}
                          getCos={getCOS}
                          contractor={contractor}
                          site_prcode={site_prcode}
                          projectName={projectName}
                          i={i}
                        />
                      }
                      {role === "Admin" &&
                        <Lock apiName="cos" id={i.id} i={i} usedFor="COS" getData={getCOS} />
                      }
                      {role === "SiteManagement" ? "" :
                        <>
                          {
                            i.lock === false &&

                            <DeleteCOS i={i} getCOS={getCOS} toggleState={toggleState} contractor={contractor} />

                          }
                        </>
                      }



                    </td>
                  }

                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>

      </div>

    </div >
  )


}





const EmployeeTable = ({ projectId, companyId, site_prcode }) => {

  const [buffer, setBuffering] = useState(false); //buffering logic
  const [loading, setLoading] = useState(false); //loading logic
  const [toggleShow, setToggleShow] = useState("null");
  const role = sessionStorage.getItem('sitemanagement_role');


  const [siteEmployeeList, setSiteEmployeeList] = useState([]);
  const [siteDepartmentList, setSiteDepartmentList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [siteProjectList, setSiteProjectList] = useState([]);

  const getSiteEmployee = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${projectId}/null/`);
      const dep = await axios.get(`${BASE_URL}/siteproject/designation/`);
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      const div = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${companyId}/`);
      // const pro = await axios.get(`${BASE_URL}/siteproject/project/`);
      const pro = await axios.get(
        sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
          `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
          : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
            `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
            // for general(admin)
            : `${BASE_URL}/siteproject/project/`
      );

      setSiteEmployeeList(res.data);
      setSiteDepartmentList(dep.data);
      setSiteSubCompanyList(div.data);
      const sortedProjects = sortProjects(pro.data, 'site_prcode');
      setSiteProjectList(sortedProjects);
    } catch (err) {
      handleErrorToast(err);

    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getSiteEmployee();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (

    <div className="info-box-div-bg">
      <div>
        <div className="jd-heading-outer-flex ">
          <h2 className="jd-heading-main font-weight600  font-size-heading">Employee</h2>
          <div className="field-cont" style={{ gap: '2px' }}>
            {/* <div className="table-searchh dropdown-container field-cont-div">
              <select
                onChange={(e) => setToggleShow(e.target.value)}
                value={toggleShow}
                className="dropdown font-size-subheading  ">
                <option value="null">All</option>
                <option value="Contractor">Contractor</option>
                <option value="Consultant">Consultant</option>
              </select>
            </div> */}
            {role === "Account" || role === "Checker" || role === "ViewAccess" ? "" :
              <>
                <AddSiteEmployee
                  projectId={projectId}
                  getSiteEmployee={getSiteEmployee}
                  siteProjectList={siteProjectList}
                  siteDepartmentList={siteDepartmentList}
                  siteSubCompanyList={siteSubCompanyList}
                  companyId={companyId}


                />
                {role === "Admin" &&
                  <UploadSiteEmployee site_prcode={site_prcode} />
                }
              </>

            }
          </div>
        </div>
        <div>
          <div className="jd-heading-bottom-bold"></div>
          <div className="jd-heading-bottom-light"></div>
        </div>
      </div>

      <div className="form-flex-wrap table-box  paddingTop-0px scroll-container-table child-table-scroll">


        <table className="table-css">
          <thead className='table-heading'>
            <tr className="custom-table-head-tr">
              <th className="table-heading-text">ID</th>
              <th className="table-heading-text text-center">Employee</th>
              <th className="table-heading-text text-center">Email</th>
              <th className="table-heading-text text-center">Mobile</th>
              <th className="table-heading-text text-center">Designation</th>
              <th className="table-heading-text text-center">Proffesional</th>
              <th className="table-heading-text text-center">Address</th>
              <th className="table-heading-text text-center">Join Date</th>
              <th className="table-heading-text text-center">Sub Company</th>
              {role === "Account" || role === "SiteManagement" || role === "Checker" || role === "ViewAccess" ? "" :
                <th className="table-heading-text text-center text-end width-5vw flex-row justify-center">Action</th>
              }
            </tr>
          </thead>
          {buffer ? <div className="spinner-smalll"></div> : null}
          <tbody>
            {siteEmployeeList?.map((i, index) => (
              <React.Fragment key={index}>

                <tr className="custom-table-head-td">
                  <td className="table-body">{index + 1}</td>
                  <td className="table-body text-center">{i.emp_code}-{i.name}</td>
                  <td className="table-body text-center">{i.email}</td>
                  <td className="table-body text-center">{i.mobile}</td>
                  <td className="table-body text-center">{i.designation_name}</td>
                  <td className="table-body text-center">{i.professional_type}</td>
                  <td className="table-body text-center">{i.current_address}</td>
                  <td className="table-body text-center">{formattedDateLong(i.joining_date)}</td>
                  <td className="table-body text-center">{i.sub_company_name}</td>

                  {role === "Account" || role === "SiteManagement" || role === "Checker" || role === "ViewAccess" ? "" :
                    <td className="text-end flex-row justify-center ">
                      {
                        i.lock === false &&

                        <UpdateSiteEmployee
                          i={i}
                          getSiteEmployee={getSiteEmployee}
                          siteProjectList={siteProjectList}
                          siteDepartmentList={siteDepartmentList}
                          siteSubCompanyList={siteSubCompanyList}
                          projectId={projectId}
                        />}

                      {role === "Admin" &&
                        <Lock apiName="employee" id={i.id} i={i} usedFor="Employee" getData={getSiteEmployee} />
                      }
                      {role === "BD" ? "" :
                        <>
                          {
                            i.lock === false &&

                            <DeleteSiteEmployee
                              i={i}
                              getSiteEmployee={getSiteEmployee}
                            />
                          }
                        </>
                      }
                    </td>
                  }
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>


      </div>

    </div>
  )

}

// const MilestoneTable = ({ projectName, projectId, contractor, site_prcode, contractor_name, toggleState }) => {

//   const [projectData, setProjectsData] = useState({});
//   const [milestoneList, setMilestoneList] = useState([]);
//   const [buffer, setBuffering] = useState(false); //buffering logic
//   const [loading, setLoading] = useState(false); //loading logic
//   const [toggleShow, setToggleShow] = useState("null");
//   const role = sessionStorage.getItem('sitemanagement_role');
//   const [contractordata, setContractorData] = useState({});

//   const getProjects = async () => {
//     setBuffering(true); //buffering logic // Start Buffering
//     try {
//       let mil = await axios.get(`${BASE_URL}/siteproject/milestonebycontractor/${contractor}/`);
//       let proj = await axios.get(`${BASE_URL}/siteproject/project/${projectId}/`);
//       const response = await axios.get(`${BASE_URL}/siteproject/contractor/${contractor}/`);
//       setContractorData(response.data)
//       setProjectsData(proj.data);

//       setMilestoneList(mil.data);
//     } catch (err) {
//       console.log("err")
//       console.log(err)
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };



//   useEffect(() => {
//     getProjects();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [toggleShow, projectId, contractor]);



//   const calculateDays = (startDate, endDate) => {
//     if (!startDate || !endDate) return "-";

//     const start = new Date(startDate);
//     const end = new Date(endDate);


//     const timeDifference = end - start;


//     const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

//     return daysDifference;
//   };

//   return (

//     <div className="info-box-div-bg">
//       <div >
//         <div className="jd-heading-outer-flex ">
//           <h2 className="jd-heading-main font-weight600  font-size-heading"> Contractor Milestone </h2>
//           <>
//             {
//               contractor === undefined ?
//                 <></>
//                 :

//                 <>
//                   {

//                     role !== "ViewAccess" &&
//                     <div className="field-cont">
//                       <AddMilstoneDetails project={projectId} getProjects={getProjects} contractor={contractor} appointed_date={contractordata.commencement_date} />
//                       {role === "Admin" && <UploadMilestoneBulk projectId={projectId} getMileStoneData={getProjects} site_prcode={site_prcode} workperformedby={toggleState} contractor_name={contractor_name} />}
//                     </div>
//                   }
//                 </>
//             }

//           </>
//         </div>
//         <div>
//           <div className="jd-heading-bottom-bold"></div>
//           <div className="jd-heading-bottom-light"></div>
//         </div>
//         <br />
//       </div>

//       <div className="form-flex-wrap table-box height-40vh paddingTop-0px scroll-container-table child-table-scroll">


//         <table className="table-css ">
//           <thead className='table-heading'>
//             <tr className="custom-table-head-tr">
//               <th className="table-heading-text text-lefttt">S. No.</th>
//               <th className="table-heading-text ">Name</th>
//               <th className="table-heading-text ">Dates</th>
//               <th className="table-heading-text ">Days</th>
//               <th className="table-heading-text">View Letters</th>
//               {role !== "ViewAccess" &&
//                 <th className="table-heading-text text-center">Action</th>
//               }

//             </tr>
//           </thead>
//           {buffer ? <div className="spinner-smalll"></div> : null}
//           <tbody>
//             {milestoneList?.sort(
//               (a, b) =>
//                 new Date(a.milestone_date) - new Date(b.milestone_date)
//             )
//               .map((i, index) => (
//                 <React.Fragment key={index}>

//                   <tr className="custom-table-head-td">
//                     <td className="table-body text-lefttt">{index + 1}.</td>
//                     <td className="table-body ">{i.name}</td>
//                     <td className="table-body text-center">
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Appointed</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {contractordata.commencement_date ? formattedDateLong(contractordata.commencement_date) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Milestone</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.milestone_date ? formattedDateLong(i.milestone_date) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Actual</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.milestone_as_per_actual ? formattedDateLong(i.milestone_as_per_actual) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Reschedule</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.milestone_as_per_reschedule ? formattedDateLong(i.milestone_as_per_reschedule) : <div className="text-center">-</div>}
//                         </td>
//                       </tr>

//                     </td>
//                     <td className="table-body">
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Milestone</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.day ? i.day : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Actual</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.actual_gap_days ? i.actual_gap_days : <div className="text-center">-</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px table-body">Reschedule</td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-start">
//                           {i.rescedule_gap_days ? i.rescedule_gap_days : <div className="text-center">-</div>}
//                         </td>
//                       </tr>

//                     </td>


//                     {i.actual_letter || i.reschedule_letter ?
//                       <td className="table-body ">

//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Actual
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end" >
//                             {i.actual_letter ? <AllAssociatedLetters id={i.actual_letter} project={i.project} workperformedby={i.workperformedby} lettertype="Milestone" buttonUI="normal" />
//                               : <div className="text-center">No Letter Attached</div>}
//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Reschedule
//                           </td>
//                           <td style={{ padding: "0px 4px" }}>:</td>
//                           <td className="text-end">
//                             {i.reschedule_letter ? <AllAssociatedLetters id={i.reschedule_letter} project={i.project} workperformedby={i.workperformedby} lettertype="Milestone" buttonUI="normal" /> : <div className="text-center">No Letter Attached</div>}
//                           </td>
//                         </tr>

//                       </td> :
//                       <td className="table-body ">No Letters Attached</td>
//                     }
//                     {role !== "ViewAccess" &&
//                       <td className="table-body text-center " style={{ display: 'flex', gap: '2px', justifyContent: 'center' }}>
//                         {i.lock === false &&
//                           <UpdateMilestone
//                             toggleState={toggleState}
//                             project={projectId}
//                             getProjects={getProjects}
//                             contractor={contractor}
//                             i={i}
//                             appointed_date={contractordata.commencement_date}
//                             site_prcode={site_prcode}
//                             projectName={projectName}
//                           />
//                         }

//                         {role === "Admin" &&
//                           <Lock apiName="milestone" id={i.id} i={i} usedFor="MileStone" getData={getProjects} />

//                         }
//                         {i.lock === false &&
//                           <>
//                             {role !== "SiteManagement" &&
//                               <DeleteMileStone i={i} getMilestone={getProjects} />
//                             }
//                           </>
//                         }


//                       </td>
//                     }

//                   </tr>
//                 </React.Fragment>
//               ))}
//           </tbody>
//         </table>

//       </div>

//     </div>
//   )


// }

const MilestoneTable = ({ grace_period, projectName, projectId, contractor, site_prcode, contractor_name, toggleState }) => {
  const [projectData, setProjectsData] = useState({});
  const [milestoneList, setMilestoneList] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const role = sessionStorage.getItem('sitemanagement_role');
  const [contractordata, setContractorData] = useState({});

  const getProjects = async () => {
    setBuffering(true);
    try {
      let mil = await axios.get(`${BASE_URL}/siteproject/milestonebycontractor/${contractor}/`);
      let proj = await axios.get(`${BASE_URL}/siteproject/project/${projectId}/`);
      const response = await axios.get(`${BASE_URL}/siteproject/contractor/${contractor}/`);
      setContractorData(response.data);
      setProjectsData(proj.data);
      setMilestoneList(mil.data);
    } catch (err) {
      console.log(err);
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getProjects();
  }, [projectId, contractor]);

  const calculateDays = (startDate, endDate) => {
    if (!startDate || !endDate) return "-";
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  };

  // Appointed Date + Days + Grace Period = Effective Deadline
  const getEffectiveDeadline = (appointedDate, days, rescheduleGapDays) => {
    if (!appointedDate) return null;

    const baseDays = (rescheduleGapDays !== null && rescheduleGapDays !== undefined && rescheduleGapDays !== "")
      ? rescheduleGapDays
      : days;

    if (baseDays === null || baseDays === undefined) return null;

    // Timezone fix - split kar do directly
    const [year, month, day] = appointedDate.split('-').map(Number);
    const date = new Date(year, month - 1, day); // Local time mein banegi, no timezone shift
    date.setDate(date.getDate() + Number(baseDays) + Number(grace_period || 0));
    return date;
  };

  const getStatusColor = (appointedDate, milestoneDay, actualDate, rescheduleGapDays) => {
    if (!actualDate) return 'pending';
    const effectiveDeadline = getEffectiveDeadline(appointedDate, milestoneDay, rescheduleGapDays);
    if (!effectiveDeadline) return 'pending';
    return new Date(actualDate) <= effectiveDeadline ? 'approved' : 'delayed';
  };

  const getStatusText = (appointedDate, milestoneDay, actualDate, rescheduleGapDays) => {
    if (!actualDate) return 'To Be Achieved';
    const effectiveDeadline = getEffectiveDeadline(appointedDate, milestoneDay, rescheduleGapDays);
    if (!effectiveDeadline) return 'To Be Achieved';
    return new Date(actualDate) <= effectiveDeadline ? 'Achieved' : 'Skipped';
  };

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const getDaysStatusClass = (days) => {
    if (!days || days === "-") return '';
    if (days < 0) return 'negative';
    if (days === 0) return 'zero';
    return 'positive';
  };

  return (
    <div className="progress-modern-container">
      {/* Header */}
      <div className="progress-header-minimal">
        <div className="header-left">
          <div className="header-icon">
            <Flag size={18} />
          </div>
          <div>
            <h3 className="header-title">Contractor Milestone</h3>
            <p className="header-title" style={{ color: "black", fontWeight: 400 }}>{contractor_name || "Contractor"} • {projectName || "Project"}</p>
          </div>
        </div>
        {role !== "ViewAccess" && (
          <div className="header-actions">
            <AddMilstoneDetails
              project={projectId}
              getProjects={getProjects}
              contractor={contractor}
              appointed_date={contractordata.commencement_date}
            />
            {role === "Admin" && (
              <UploadMilestoneBulk
                projectId={projectId}
                getMileStoneData={getProjects}
                site_prcode={site_prcode}
                workperformedby={toggleState}
                contractor_name={contractor_name}
              />
            )}
          </div>
        )}
      </div>

      {/* Stats Summary */}
      <div className="stats-minimal-row">
        <div className="stat-minimal-item">
          <Flag size={14} />
          <span>Total Milestones</span>
          <strong>{milestoneList.length}</strong>
        </div>
        <div className="stat-minimal-item">
          <CheckCircle size={14} />
          <span>Achieved</span>
          <strong>{/* Achieved count */}
            {milestoneList.filter(m => {
              if (!m.milestone_as_per_actual) return false;
              const deadline = getEffectiveDeadline(
                contractordata.commencement_date,
                m.day,
                m.rescedule_gap_days ?? null
              );
              return deadline && new Date(m.milestone_as_per_actual) <= deadline;
            }).length}</strong>
        </div>
        <div className="stat-minimal-item">
          <Clock size={14} />
          <span>To be Achieved</span>
          <strong>{milestoneList.filter(m => !m.milestone_as_per_actual && m.milestone_date).length}</strong>
        </div>
        <div className="stat-minimal-item">
          <Cross size={14} />
          <span>Skipped</span>
          <strong>{/* Skipped count */}
            {milestoneList.filter(m => {
              if (!m.milestone_as_per_actual) return false;
              const deadline = getEffectiveDeadline(
                contractordata.commencement_date,
                m.day,
                m.rescedule_gap_days ?? null
              );
              return deadline && new Date(m.milestone_as_per_actual) > deadline;
            }).length}</strong>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper-minimal">
        {buffer ? (
          <div className="loader-minimal">
            <div className="spinner-minimal"></div>
          </div>
        ) : (
          <table className="progress-table-minimal">
            <thead>
              <tr>
                <th className="col-sno">#</th>
                <th className="col-milestone-name">Milestone Name /Letters</th>
                <th className="col-dates text-center">Dates</th>
                <th className="col-days text-center" >Days</th>
                <th className="col-status text-center">Status</th>
                <th className="col-letters text-center">Percentage</th>
                {role !== "ViewAccess" && <th className="col-action text-center">Action</th>}
              </tr>
            </thead>
            <tbody>
              {milestoneList
                .sort((a, b) => new Date(a.milestone_date) - new Date(b.milestone_date))
                .map((item, index) => {
                  const isExpanded = expandedRow === index;
                  const status = getStatusText(
                    contractordata.commencement_date,
                    item.day,
                    item.milestone_as_per_actual,
                    item.rescedule_gap_days ?? null
                  );
                  const statusType = getStatusColor(
                    contractordata.commencement_date,
                    item.day,
                    item.milestone_as_per_actual,
                    item.rescedule_gap_days ?? null
                  );
                  const hasDelay = statusType === 'delayed';

                  return (
                    <React.Fragment key={index}>
                      <tr className={`progress-row ${hasDelay ? 'has-pending' : ''}`}>
                        <td className="col-sno text-start">{index + 1}</td>
                        <td className="col-milestone-name">
                          <button className="period-trigger" onClick={() => toggleRow(index)}>
                            <Flag size={12} />
                            <span>{item.name}</span>
                            {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                          </button>
                        </td>
                        <td className="col-dates">
                          <div className="dates-container">
                            <div className="date-item">
                              <span className="date-label">Appointed:</span>
                              <span className="date-value">
                                {contractordata.commencement_date ? formattedDateLong(contractordata.commencement_date) : '-'}
                              </span>
                            </div>

                            <div className="date-item">
                              <span className="date-label">Milestone:</span>
                              <span className="date-value">
                                {item.milestone_date ? formattedDateLong(item.milestone_date) : '-'}
                              </span>
                            </div>
                            <div className="date-item">
                              <span className="date-label">Reschedule:</span>
                              <span className="date-value">
                                {item.milestone_as_per_reschedule ? formattedDateLong(item.milestone_as_per_reschedule) : '-'}
                              </span>
                            </div>
                            <div className="day-item">
                              <span className="day-label">Deadline:</span>
                              <span className="day-value">
                                {(() => {
                                  const d = getEffectiveDeadline(
                                    contractordata.commencement_date,
                                    item.day,
                                    item.rescedule_gap_days ?? null
                                  );
                                  return d ? formattedDateLong(d.toISOString().split('T')[0]) : '-';
                                })()}
                              </span>
                            </div>
                            <div className="date-item">
                              <span className="date-label">Actual:</span>
                              <span className={`date-value ${item.milestone_as_per_actual ? 'has-value' : ''}`}>
                                {item.milestone_as_per_actual ? formattedDateLong(item.milestone_as_per_actual) : '-'}
                              </span>
                            </div>

                          </div>
                        </td>
                        <td className="col-days">
                          <div className="days-container">
                            <div className="day-item">
                              <span className="day-label">-</span>
                              <span className={`day-value ${getDaysStatusClass(item.day)}`}>
                                -
                              </span>
                            </div>

                            <div className="day-item">
                              <span className="day-label">Milestone:</span>
                              <span className={`day-value ${getDaysStatusClass(item.day)}`}>
                                {item.day ? `${item.day} days` : '-'}
                              </span>
                            </div>
                            <div className="day-item">
                              <span className="day-label">Reschedule:</span>
                              <span className={`day-value ${getDaysStatusClass(item.rescedule_gap_days)}`}>
                                {item.rescedule_gap_days ? `${item.rescedule_gap_days} days` : '-'}
                              </span>
                            </div>
                            <div className="day-item">
                              <span className="day-label">Grace Period:</span>
                              <span className="day-value">
                                {grace_period ? `${grace_period} days` : '-'}
                              </span>
                            </div>

                            {/* Effective Deadline row — shows the computed final date */}


                            <div className="day-item">
                              <span className="day-label">Actual:</span>
                              <span className={`day-value ${getDaysStatusClass(item.actual_gap_days)}`}>
                                {item.actual_gap_days ? `${item.actual_gap_days} days` : '-'}
                              </span>
                            </div>

                          </div>
                        </td>
                        <td className="col-status text-center">
                          <span className={`status-badge-minimal ${statusType === 'approved' ? 'approved' : statusType === 'delayed' ? 'pending' : 'warning'}`}>
                            {status}
                          </span>
                        </td>
                        <td className="col-status text-center">
                          <span className={`status-badge-minimal ${statusType === 'approved' ? 'approved' : statusType === 'delayed' ? 'pending' : 'warning'}`}>
                            {item.milestone_percentage}
                          </span>
                        </td>

                        {role !== "ViewAccess" && (
                          <td className="col-action">
                            <div className="action-group-minimal">
                              {item.lock === false && (
                                <UpdateMilestone
                                  toggleState={toggleState}
                                  project={projectId}
                                  getProjects={getProjects}
                                  contractor={contractor}
                                  i={item}
                                  appointed_date={contractordata.commencement_date}
                                  site_prcode={site_prcode}
                                  projectName={projectName}
                                />
                              )}
                              {role === "Admin" && (
                                <Lock
                                  apiName="milestone"
                                  id={item.id}
                                  i={item}
                                  usedFor="MileStone"
                                  getData={getProjects}
                                />
                              )}
                              {item.lock === false && role !== "SiteManagement" && (
                                <DeleteMileStone i={item} getMilestone={getProjects} />
                              )}
                            </div>
                          </td>
                        )}
                      </tr>

                      {/* Expanded Row - Full Letter Details */}
                      {isExpanded && (
                        <tr className="expanded-row">
                          <td colSpan={role !== "ViewAccess" ? 7 : 6}>
                            <div className="expanded-content">
                              <div className="letters-section">
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <FileText size={14} />
                                    <span>Actual Achievement Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    {item.actual_letter ? (
                                      <AllAssociatedLetters
                                        id={item.actual_letter}
                                        project={item.project}
                                        workperformedby={item.workperformedby}
                                        lettertype="Milestone"
                                        buttonUI="normal"
                                      />
                                    ) : (
                                      <span className="no-letter">No letter attached</span>
                                    )}
                                  </div>
                                </div>
                                <div className="letter-card">
                                  <div className="letter-header">
                                    <Calendar size={14} />
                                    <span>Reschedule Letter</span>
                                  </div>
                                  <div className="letter-body">
                                    {item.reschedule_letter ? (
                                      <AllAssociatedLetters
                                        id={item.reschedule_letter}
                                        project={item.project}
                                        workperformedby={item.workperformedby}
                                        lettertype="Milestone"
                                        buttonUI="normal"
                                      />
                                    ) : (
                                      <span className="no-letter">No letter attached</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
// const Progress = ({ projectName, projectId, contractor, contractor_name, site_prcode }) => {
//   const [progress, setProgress] = useState([]);
//   const [buffer, setBuffering] = useState(false); // Buffering logic
//   const [loading, setLoading] = useState(false); // Loading logic
//   const role = sessionStorage.getItem('sitemanagement_role');

//   const [physicalProgress, setPhysicalProgress] = useState([]);


//   const [progressdata, setProgressData] = useState([]);


//   const getProgress = async () => {
//     setBuffering(true); // Start buffering

//     try {
//       const response = await axios.get(`${BASE_URL}/siteproject/progressbyproject/${projectId}/${contractor}/`);

//       setProgressData(response.data)

//       const filteredData = response.data.map(item => ({
//         physical_progress: item.physical_progress,
//         estimated_physical_progress: item.estimated_physical_progress,
//         month: item.month
//       }));

//       setPhysicalProgress(filteredData);


//       const sortedData = response.data.sort((a, b) => {
//         if (a.year === b.year) {
//           return b.month - a.month;
//         }
//         return b.year - a.year;
//       });


//       setProgress(sortedData);
//     } catch (err) {
//       console.log("err");
//       console.log(err);
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false); // End buffering
//     }
//   };
//   console.log(projectId)
//   useEffect(() => {
//     getProgress();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [projectId, contractor]);


//   const handleProgressDelete = async (e, i, getProgress) => {
//     e.preventDefault();


//     setLoading(true); // loading logic
//     const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

//     try {
//       let res = await axios.delete(`${BASE_URL}/siteproject/progressupdate/${i.id}/`);

//       if (res.status === 200) {
//         await getProgress();
//       } else {
//         alert(res);
//       }
//     } catch (err) {
//       // toast logic
//       handleErrorToast(err);
//     } finally {
//       setLoading(false); // loading logic
//       toast.dismiss(loadingToastId);
//     }
//   }

//   const getMonthName = (monthNumber) => {
//     const months = [
//       'January', 'February', 'March', 'April', 'May', 'June',
//       'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     return months[monthNumber - 1];
//   };


//   return (
//     <>
//       <div className="info-box-div-bg">
//         <div>
//           <div className="jd-heading-outer-flex">
//             <h2 className="jd-heading-main font-weight600 font-size-heading">Site Progress</h2>
//             <div className='flex-row'>
//               {
//                 role !== "Checker" && role !== "ViewAccess" &&
//                 <div className="field-cont">
//                   <AddProgressdetails project={projectId} contractor={contractor} getprogressDetails={getProgress} progressdata={progressdata} site_prcode={site_prcode}
//                     projectName={projectName} />
//                   {role === "Admin" && <UploadSiteProgressBulk getProgress={getProgress} contractor_name={contractor_name} site_prcode={site_prcode} />}
//                 </div>

//               }
//             </div>
//           </div>
//           <div>
//             <div className="jd-heading-bottom-bold"></div>
//             <div className="jd-heading-bottom-light"></div>
//           </div>
//         </div>

//         <div className="form-flex-wrap table-box paddingTop-0px scroll-container-table child-table-scroll">
//           <table className="table-css">
//             <thead className='table-heading'>
//               <tr className="custom-table-head-tr">
//                 <th className="table-heading-text text-lefttt">S. No.</th>
//                 <th className="table-heading-text">Month</th>
//                 <th className="table-heading-text">Year</th>
//                 <th className="table-heading-text text-center">Submitted Progress (%)</th>
//                 <th className="table-heading-text text-center">Approved Progress (%)</th>
//                 <th className="table-heading-text text-center">Letters</th>

//                 {role !== "Checker" && role !== "ViewAccess" &&
//                   <th className="table-heading-text text-center ">Action</th>
//                 }
//               </tr>
//             </thead>
//             {buffer ? <div className="spinner-smalll"></div> : null}
//             <tbody>
//               {progress.map((i, index) => (
//                 <React.Fragment key={index}>

//                   <tr className="custom-table-head-td">
//                     <td className="table-body text-lefttt">{index + 1}.</td>
//                     <td className="table-body">{getMonthName(i.month)}</td>
//                     <td className="table-body">{i.year}</td>
//                     <td className="table-body width-15vw">
//                       <div className='flex-column justify-center' style={{ alignItems: "center" }}>

//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Physical Progress
//                           </td>
//                           <td style={{ padding: "0px 10px" }}>:</td>
//                           <td className="text-start">{i.submitted_physical_progress ? i.submitted_physical_progress : "0"} %</td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Financial Progress
//                           </td>
//                           <td style={{ padding: "0px 10px" }}>:</td>
//                           <td className="text-start">{i.submitted_financial_progress ? i.submitted_financial_progress : "0"} %</td>
//                         </tr>
//                       </div>

//                     </td>
//                     <td className="table-body width-15vw">
//                       <div className='flex-column justify-center' style={{ alignItems: "center" }}>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Physical Progress
//                           </td>
//                           <td style={{ padding: "0px 10px" }}>:</td>
//                           <td className="text-start">{i.physical_progress} %</td>
//                         </tr>
//                         <tr>
//                           <td className="padding-bottom-5px">
//                             Financial Progress
//                           </td>
//                           <td style={{ padding: "0px 10px" }}>:</td>
//                           <td className="text-start">{i.financial_progress} %</td>
//                         </tr>
//                       </div>


//                     </td>
//                     <td className="table-body">
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Submitted
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end" >
//                           {i.submitted_letter ? <AllAssociatedLetters id={i.submitted_letter} project={i.project} workperformedby="contractor" lettertype="SiteProgress" buttonUI="normal" />
//                             : <div className="text-center">No Letter Attached</div>}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="padding-bottom-5px">
//                           Approved
//                         </td>
//                         <td style={{ padding: "0px 4px" }}>:</td>
//                         <td className="text-end" >
//                           {i.approved_letter ? <AllAssociatedLetters id={i.approved_letter} project={i.project} workperformedby="contractor" lettertype="SiteProgress" buttonUI="normal" />
//                             : <div className="text-center">No Letter Attached</div>}
//                         </td>
//                       </tr>

//                     </td>

//                     {role !== "Checker" && role !== "ViewAccess" &&
//                       <td className="table-body  text-center flex-row justify-center">
//                         {i.lock === false &&
//                           <>
//                             <UpdateProgressdetails i={i} project={projectId} getprogressDetails={getProgress} progressdata={progress} contractor={contractor} site_prcode={site_prcode}
//                               projectName={projectName} />
//                           </>
//                         }

//                         {role === "Admin" &&
//                           <Lock apiName="progressupdate" id={i.id} i={i} usedFor="Site Progress" getData={getProgress} />

//                         }
//                         {i.lock === false &&
//                           <>
//                             {role !== "SiteManagement" &&
//                               <button className="model-delete-button"
//                                 onClick={(e) => handleProgressDelete(e, i, getProgress)}
//                               >
//                                 <DeleteDustbin />
//                               </button>
//                             }
//                           </>
//                         }
//                       </td>
//                     }
//                   </tr>
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         </div>

//       </div>
//     </>
//   );
// };




const Progress = ({ projectName, projectId, contractor, contractor_name, site_prcode }) => {
  const [progress, setProgress] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [loading, setLoading] = useState(false);
  const role = sessionStorage.getItem('sitemanagement_role');
  const [expandedRow, setExpandedRow] = useState(null);
  const [progressdata, setProgressData] = useState([]);

  const getProgress = async () => {
    setBuffering(true);
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/progressbyproject/${projectId}/${contractor}/`);
      setProgressData(response.data);

      const sortedData = response.data.sort((a, b) => {
        if (a.year === b.year) return b.month - a.month;
        return b.year - a.year;
      });
      setProgress(sortedData);
    } catch (err) {
      console.error(err);
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getProgress();
  }, [projectId, contractor]);

  const handleProgressDelete = async (e, i) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/progressupdate/${i.id}/`);
      if (res.status === 200) {
        await getProgress();
        toast.success("Progress deleted successfully");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const getMonthName = (monthNumber) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthNumber - 1];
  };

  const getProgressColor = (submitted, approved) => {
    if (submitted > approved) return '#f59e0b';
    if (submitted === approved && submitted > 0) return '#10b981';
    return '#64748b';
  };

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <div className="progress-modern-container">
      {/* Header */}
      <div className="progress-header-minimal">
        <div className="header-left">
          <div className="header-icon">
            <Activity size={18} />
          </div>
          <div>
            <h3 className="header-title">Site Progress</h3>
            <p style={{ color: "black", fontSize: "10px" }}>{contractor_name || "Contractor"} • {projectName || "Project"}</p>
          </div>
        </div>
        {role !== "Checker" && role !== "ViewAccess" && (
          <div className="header-actions">
            <AddProgressdetails
              project={projectId}
              contractor={contractor}
              getprogressDetails={getProgress}
              progressdata={progressdata}
              site_prcode={site_prcode}
              projectName={projectName}
            />
            {role === "Admin" && (
              <UploadSiteProgressBulk
                getProgress={getProgress}
                contractor_name={contractor_name}
                site_prcode={site_prcode}
              />
            )}
          </div>
        )}
      </div>

      {/* Stats Summary */}
      <div className="stats-minimal-row">
        <div className="stat-minimal-item">
          <BarChart3 size={14} />
          <span>Total Records</span>
          <strong>{progress.length}</strong>
        </div>
        <div className="stat-minimal-item">
          <CheckCircle size={14} />
          <span>Approved</span>
          <strong>{progress.filter(p => p.physical_progress).length}</strong>
        </div>
        <div className="stat-minimal-item">
          <Clock size={14} />
          <span>Pending</span>
          <strong>{progress.filter(p => !p.physical_progress).length}</strong>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper-minimal">
        {buffer ? (
          <div className="loader-minimal">
            <div className="spinner-minimal"></div>
          </div>
        ) : (
          <table className="progress-table-minimal">
            <thead>
              <tr>
                <th className="col-sno text-center" >#</th>
                <th className="col-period">Period/Letters</th>
                <th className="col-submitted text-center">Submitted</th>
                <th className="col-approved text-center">Approved</th>
                <th className="col-status ">Status</th>
                {role !== "Checker" && role !== "ViewAccess" && <th className="col-action text-center">Action</th>}
              </tr>
            </thead>
            <tbody>
              {progress.map((item, index) => {
                const isPending = !item.physical_progress ||
                  !item.financial_progress;
                const isExpanded = expandedRow === index;

                return (
                  <React.Fragment key={index}>
                    <tr className={`progress-row ${isPending ? 'has-pending' : ''}`}>
                      <td className="col-sno">{index + 1}</td>
                      <td className="col-period">
                        <button className="period-trigger" onClick={() => toggleRow(index)}>
                          <Calendar size={12} />
                          <span>{getMonthName(item.month)} {item.year}</span>
                          {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                        </button>
                      </td>
                      <td className="col-submitted">
                        <div className="progress-badge">
                          <span className="badge-label">Physical</span>
                          <span className="badge-value">{item.submitted_physical_progress || 0}%</span>
                        </div>
                        <div className="progress-badge">
                          <span className="badge-label">Financial</span>
                          <span className="badge-value">{item.submitted_financial_progress || 0}%</span>
                        </div>
                      </td>
                      <td className="col-approved">
                        <div className="progress-badge approved">
                          <span className="badge-label">Physical</span>
                          <span className={`badge-value ${!item.physical_progress ? 'pending' : ''}`}>
                            {item.physical_progress}%
                          </span>
                        </div>
                        <div className="progress-badge approved">
                          <span className="badge-label">Financial</span>
                          <span className={`badge-value ${!item.financial_progress ? 'pending' : ''}`}>
                            {item.financial_progress}%
                          </span>
                        </div>
                      </td>
                      <td className="col-status">
                        <span className={`status-badge-minimal ${isPending ? 'pending' : 'approved'}`}>
                          {isPending ? 'Pending Approval' : 'Approved'}
                        </span>
                      </td>
                      {role !== "Checker" && role !== "ViewAccess" && (
                        <td className="col-action">
                          <div className="action-group-minimal">
                            {item.lock === false && (
                              <UpdateProgressdetails
                                i={item}
                                project={projectId}
                                getprogressDetails={getProgress}
                                progressdata={progress}
                                contractor={contractor}
                                site_prcode={site_prcode}
                                projectName={projectName}
                              />
                            )}
                            {role === "Admin" && (
                              <Lock
                                apiName="progressupdate"
                                id={item.id}
                                i={item}
                                usedFor="Site Progress"
                                getData={getProgress}
                              />
                            )}
                            {item.lock === false && role !== "SiteManagement" && (
                              <button className="model-delete-button" onClick={(e) => handleProgressDelete(e, item)}>
                                <Trash2 size={14} />
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>

                    {/* Expanded Row - Letters */}
                    {isExpanded && (
                      <tr className="expanded-row">
                        <td colSpan={role !== "Checker" && role !== "ViewAccess" ? 6 : 5}>
                          <div className="expanded-content">
                            <div className="letters-section">
                              <div className="letter-card">
                                <div className="letter-header">
                                  <FileText size={14} />
                                  <span>Submitted Letter</span>
                                </div>
                                <div className="letter-body">
                                  {item.submitted_letter ? (
                                    <AllAssociatedLetters
                                      id={item.submitted_letter}
                                      project={item.project}
                                      workperformedby="contractor"
                                      lettertype="SiteProgress"
                                      buttonUI="normal"
                                    />
                                  ) : (
                                    <span className="no-letter">No letter attached</span>
                                  )}
                                </div>
                              </div>
                              <div className="letter-card">
                                <div className="letter-header">
                                  <CheckCircle size={14} />
                                  <span>Approved Letter</span>
                                </div>
                                <div className="letter-body">
                                  {item.approved_letter ? (
                                    <AllAssociatedLetters
                                      id={item.approved_letter}
                                      project={item.project}
                                      workperformedby="contractor"
                                      lettertype="SiteProgress"
                                      buttonUI="normal"
                                    />
                                  ) : (
                                    <span className="no-letter">No letter attached</span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};



const ProjectProgressBar = ({ data }) => {
  const renderCustomLabel = ({ x, y, width, height, value, index, dataKey }) => {
    const midX = x + width / 2;
    const midY = y + height / 2;
    const label = dataKey === 'Physical' ? 'Physical' : 'Financial';

    return (
      <text
        x={midX}
        y={midY}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="middle"
        transform={`rotate(-90, ${midX}, ${midY})`}
        className="font-size-subheading"
      >
        {label}
      </text>
    );
  };


  return (
    <div style={{ padding: 0 }} className="width-5vw">
      <ResponsiveContainer height={200} width="100%">
        <BarChart
          margin={{
            top: 15,
            right: 0,
            left: 0,
            bottom: 0,
          }}
          barGap={15}
          barCategoryGap={30}
          data={data}>
          <CartesianGrid horizontal="true" vertical="" strokeDasharray="10 6" />
          <XAxis dataKey="month" />
          <Tooltip />
          <Bar label={{ position: 'top' }} legendType="line" dataKey="Physical" fill="#2576BC" barSize={20} radius={7} >
            <LabelList content={(props) => renderCustomLabel({ ...props, dataKey: 'Physical' })} />
          </Bar>
          <Bar label={{ position: 'top' }} legendType="line" dataKey="Financial" fill="#00dec7" barSize={20} radius={7} >
            <LabelList content={(props) => renderCustomLabel({ ...props, dataKey: 'Financial' })} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}






const LetterTracking = ({ site_prcode, contractor_name, projectName, projectId, letterBy, contractor, contractorlist }) => {
  const tableRef = useRef(null);
  const subCompanyId = sessionStorage.getItem('sitemanagement_project_sub_company');
  const [toggleCompany, setToggleCompany] = useState("");
  const role = sessionStorage.getItem('sitemanagement_role');


  const [workperformedby, setWorkperformedby] = useState("null");

  const [lettertype, setLetterType] = useState("null");

  const [letterData, setLetterData] = useState([]);


  const getLetterTat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/siteproject/tatdurationfilter/59408e4e-a455-46b6-b3db-8deaa0ae4475/`);

      setLetterData(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getLetterTat();
  }, []);



  const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState(null);

  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState('null');
  const [selectedToDate, setToDate] = useState('null');
  const [selectedLetterStatus, setLetterStatus] = useState('null');


  const [trackRecordList, setTrackRecordList] = useState([]);


  const [buffer, setBuffering] = useState(true); //buffering logic

  const getProjects = async () => {
    setBuffering(true); // Start Buffering
    try {


      const res = await axios.get(`${BASE_URL}/siteproject/letterrecords/filter/${selectedLetterStatus}/${selectedFromDate}/${selectedToDate}/null/${projectId}/${letterBy ? letterBy : workperformedby}/${lettertype}/null/null/${contractor}/null/`);
      setTrackRecordList(res.data);


    } catch (err) {
      // handleErrorToast(err); // You can handle any general error here if needed
    } finally {
      setBuffering(false); // End Buffering
    }
  };


  useEffect(() => {
    getProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleCompany, selectedLetterStatus, selectedFromDate, selectedToDate, workperformedby, lettertype, contractor, letterBy]);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNo, trackRecordList]);

  const applyFilters = () => {
    let filteredData = trackRecordList;
    if (selectedNo !== "") {
      const lowercaseSelectedName = selectedNo.toLowerCase();
      filteredData = filteredData.filter(employee => {
        const lid = employee.letter_num.toString().toLowerCase().includes(lowercaseSelectedName) || employee.subject.toLowerCase().includes(lowercaseSelectedName);
        return lid;
      });
    }



    filteredData = filteredData.sort((a, b) => {
      const dateA = new Date(a.letter_date);
      const dateB = new Date(b.letter_date);
      return dateB - dateA;
    });


    setFilteredData(filteredData);
  };


  function calculateDaysBetweenDates(targetDate) {
    if (!targetDate) return '-';

    const today = new Date();
    const givenDate = new Date(targetDate);

    // Remove time portion for accurate difference
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    const diffTime = Math.abs(givenDate.getTime() - today.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;

  }

  const [lettertypelist, setLettertypeList] = useState([]);


  const getLetterTypeData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/siteproject/LetterHeadingfilter/${subCompanyId !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? "59408e4e-a455-46b6-b3db-8deaa0ae4475" : "48cb62b4-9b60-4305-b6b4-b9da5d1baaf5"}/`
      );
      setLettertypeList(response.data);
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    getLetterTypeData();
  }, []);

  const LetterTypeOptions = lettertypelist
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({
      value: i.name,
      label: i.name,
      work_performed_by: i.work_performed_by,
    }));
  const extendedLetterTypeOptions = [
    ...LetterTypeOptions,
    { label: "Other", value: "other", work_performed_by: "For Both" },
  ];

  const handleLetterTypeOption = (selectedOption) => {
    if (!selectedOption) {
      setLetterType("null");
    } else {
      setLetterType(selectedOption.value);
    }
  };





  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div >
        <>
          <div>
            <div className="attendance-heading  font-weight500    font-size-heading"> </div>
            <div className="attendance-subcontainer" style={{ padding: "15px 30px 15px 58px" }}>
              <div className="field-cont" style={{ maxWidth: "60vw" }}>

                <LetterStatus selectedLetterStatus={selectedLetterStatus} setLetterStatus={setLetterStatus} />

                <LetterType
                  setLetterType={setLetterType}
                  lettertype={lettertype}
                  LetterTypeOptions={extendedLetterTypeOptions}
                  handleChange={handleLetterTypeOption}
                />
                <div title='Search Filter' className="field-cont-div">
                  <SearchSmall />
                  <input className="attendance-input-field  width-25vw"
                    placeholder='Letter No. / Subject / Remarks'
                    type="text"
                    value={selectedNo}
                    onChange={(e) => setNo(e.target.value)} />

                  <hr className="field-cont-hr" />
                </div>
                {letterBy === undefined &&
                  <>
                    <div title="Letter for" className="field-cont-div">
                      <CircularGrid />
                      <select
                        onChange={(e) => setWorkperformedby(e.target.value)}
                        value={workperformedby}
                        className="attendance-input-field width-10vw   date-field"
                      >
                        <option value="null">Select Option</option>
                        <option value="contractor">Contractor</option>
                        <option value="consultant">Consultant</option>

                      </select>

                      <hr className="field-cont-hr" />
                    </div>

                  </>}



                <div title="From Date Filter" className="field-cont-div">
                  <input
                    className="attendance-input-field width-10vw   date-field"
                    placeholder="From Date"
                    type="date"
                    value={selectedFromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <hr className="field-cont-hr" />
                </div>

                <div title="To Date Filter" className="field-cont-div ">
                  <input
                    className="attendance-input-field width-10vw   date-field"
                    placeholder="To Date"
                    type="date"
                    value={selectedToDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <hr className="field-cont-hr" />
                </div>

              </div>


              <div className="btn-cont width-20vw float-right" style={{ gap: '2px' }}>
                {
                  contractor === undefined ?
                    <></>
                    :
                    <>
                      {role !== "ViewAccess" &&
                        <>
                          {role === "BD" ? "" :
                            <>
                              <AddLetterLinked projectName={projectName} siteCode={site_prcode} LetterTypeOptions={extendedLetterTypeOptions} contractor={contractor} getProjects={getProjects} letterfor={letterBy} projectId={projectId} contractorlist={{ contractorlist }} letterData={letterData} title={letterBy === 'contractor' ? "Contractor Letter" : "Consultant Letter"} />

                            </>
                          }
                          {role === "Admin" && <UploadLetterBulk contractor_name={contractor_name} letterBy={letterBy} getLetters={getProjects} site_prcode={site_prcode} />}
                        </>
                      }
                    </>


                }



              </div>
            </div>
          </div>


          <div className="info-box-div-bg  table-box paddingTop-0px scroll-container-table child-table-scroll" style={{ marginTop: "10px", minHeight: "60vh" }} >

            <table ref={tableRef} className="table-css">
              <thead className='table-heading'>
                <tr className='custom-table-head-tr'>
                  <th className='table-heading-text text-left-sr'>S.no.</th>
                  <th className='table-heading-text'>Letter No.</th>
                  <th className='table-heading-text'>Subject</th>

                  <th className='table-heading-text ' style={{ paddingLeft: "110px" }}>Letter Details</th>
                  <th className='table-heading-text text-center'>Dates</th>
                  <th className='table-heading-text ' style={{ paddingLeft: "90px" }}>From/To</th>
                  {role === "BD" || role === "ViewAccess" ? "" :
                    <>
                      <th className='table-heading-text text-center'>Action</th>
                    </>
                  }
                </tr>
              </thead>

              <>
                {buffer ? <div className="spinner-smalll"></div> : null}
                <tbody>
                  {/* {filteredData.sort((a,b) => b.date - a.date).map((i, index) => ( */}
                  {Array.isArray(filteredData) &&
                    filteredData
                      .sort((a, b) => new Date(b.letter_date) - new Date(a.letter_date))
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          <tr className="custom-table-head-td " >

                            <td className="table-body form-text-transformation-uppercase">
                              {index + 1}.
                            </td>


                            <td className="table-body form-text-transformation-uppercase">
                              <div
                                style={{
                                  width: "120px",
                                  wordBreak: "break-word", // Ensures words break at the container width
                                  whiteSpace: "normal",    // Allows wrapping to the next line
                                }}
                              >
                                {i.letter_num}
                              </div>
                            </td>
                            <td className='table-body'><div style={{ width: "100px", whiteSpace: "normal" }}>{i.subject ? i.subject : <p className=''>-</p>}</div></td>


                            <td className="table-body width-20vw">
                              <div className="flex-column ">

                                <table>
                                  <tbody className="table-body">
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Exchange Type</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.letterExchange
                                            ? i.letterExchange
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Letter Type</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.lettertype
                                            ? i.lettertype
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Status</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.status
                                            ? i.status
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">TAT Duration</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.tat_duration
                                            ? i.tat_duration
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Due Days</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>

                                          {i.end_date ? calculateDaysBetweenDates(i.end_date) : "-"}

                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Remarks</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.remarks
                                            ? <CustomModel i={i.remarks} usedFor="nestedTable" title="Remarks" />
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>

                                      <td className="padding-bottom-5px text-start">Associated Letters</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>

                                          <AllAssociatedLetters id={i.id} project={i.project} workperformedby={i.workperformedby} lettertype={i.lettertype} buttonUI="normal" />



                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">View Letter</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          <DocumentModel letterrecord={i.id} letterData={i.letter_tracking} title={"Documents"} getDocument={getProjects} usedFor="nestedTable" />
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>

                            <td className="table-body width-15vw">
                              <div className="flex-column align-items-center">
                                <table>
                                  <tbody className="table-body">
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Letter Date</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">{i.letter_date !== null ? formattedDateLong(i.letter_date) : "-"}</td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Letter Add</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">{i.created_at !== null ? formattedDateLong(i.created_at) : "-"}</td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Deadline</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">{i.end_date !== null ? formattedDateLong(i.end_date) : "-"}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>


                            <td className="table-body width-15vw">
                              <div className="flex-column align-items-center">

                                <table>
                                  <tbody className="table-body">
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Letter From</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.letter_from
                                            ? i.letter_from
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="padding-bottom-5px text-start">Letter To</td>
                                      <td style={{ padding: "0px 10px" }}>:</td>
                                      <td className="text-start">
                                        <div style={{ width: "100px", whiteSpace: "normal" }}>
                                          {i.letter_to
                                            ? i.letter_to
                                            : "-"}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>


                            {role === "BD" ? "" :
                              <>
                                {role !== "ViewAccess" &&
                                  <td className='table-body flex-row justify-center '>
                                    {i.lock === false &&
                                      <>
                                        <UpdateTrackRecordDetails
                                          i={i}
                                          getProjects={getProjects}
                                          projectId={projectId}
                                          siteCode={site_prcode}
                                          projectName={projectName}
                                          letterType={i.lettertype}
                                          letter
                                          workperformedby={i.workperformedby}
                                          associatedletters={i.associated_letters}
                                          letterData={letterData}
                                          subCompanyId={subCompanyId}
                                          LetterTypeOptions={extendedLetterTypeOptions}


                                        // associatedletters={i.associated_letters_get[0].letter_num }
                                        />
                                      </>
                                    }
                                    {role === "Admin" &&
                                      <Lock apiName="documentbulkwithletterupdate" id={i.id} i={i} usedFor="Letter" getData={getProjects} />

                                    }
                                    {i.lock === false &&
                                      <>
                                        {role === 'Admin' ?
                                          <DeleteTrackAndLetterDetails i={i} getLetterDetail={getProjects} /> : ""}
                                      </>
                                    }


                                  </td>
                                }

                              </>
                            }
                          </tr>
                        </React.Fragment>
                      ))}

                </tbody>
              </>

            </table>


          </div>
        </>
      </div >
    </>
  );
}


const MiscellaneousDocument = ({ projectId, p_id, toggleState, contractor, contractorlist, site_prcode, contractor_name }) => {
  const [docList, setDocList] = useState([]);
  const [buffer, setBuffer] = useState(false);
  const role = sessionStorage.getItem('sitemanagement_role');


  const getDocument = async () => {


    try {
      setBuffer(true)
      let eot = await axios.get(`${BASE_URL}/siteproject/documentwithmiscellaneousget/${p_id}/`);
      setDocList(eot.data);


    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffer(false)
    }
  };
  useEffect(() => {
    getDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p_id]);

  return (

    <div className="info-box-div-bg ">
      <div >
        <div className="jd-heading-outer-flex ">
          <div className='flex-row justify-between' style={{ width: "100%" }}>
            <h2 className="jd-heading-main font-weight600  font-size-heading">Miscellaneous Documents</h2>
            {role !== "ViewAccess" &&
              <DocumentModel title={"Miscellaneous Document"} p_id={p_id} getDocument={getDocument} document_for={toggleState} />
            }
          </div>
        </div>
        <div>
          <div className="jd-heading-bottom-bold" style={{ width: "254px" }}></div>
          <div className="jd-heading-bottom-light"></div>
        </div>
      </div>

      <div className="form-flex-wrap table-box paddingTop-0px scroll-container-table child-table-scroll">
        <table className="table-css">
          <thead className='table-heading'>
            <tr className="custom-table-head-tr">
              <th className="table-heading-text text-lefttt">S. No.</th>
              <th className="table-heading-text text-center">Document Name </th>
              <th className="table-heading-text text-center">Document File </th>
              {role !== "SiteManagement" && role !== "ViewAccess" &&
                <th className="table-heading-text width-5vw text-end">Action</th>
              }
            </tr>
          </thead>
          {buffer ? <div className="spinner-smalll"></div> : null}
          <tbody>
            {toggleState === "consultant" ?
              docList?.filter(i => i.document_type === "actual" || i.document_type === null)?.map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="custom-table-head-td">
                    <td className="table-body text-lefttt">{index + 1}.</td>
                    <td className="table-body text-center">{i.document_name}</td>
                    <td className="table-body text-center">
                      {i.document_file ? (
                        <a href={i.document_file} target="_blank" rel="noopener noreferrer">
                          <DocumentIcon />
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                      <td className="table-body text-end">
                        <Updatedocument i={i} getData={getDocument} />
                        <DeleteDocuments i={i} getDocument={getDocument} />
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              ))
              :
              docList?.filter(i => i.document_type === "boq" || i.document_type === null)?.map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="custom-table-head-td">
                    <td className="table-body text-lefttt">{index + 1}.</td>
                    <td className="table-body text-center">{i.document_name}</td>
                    <td className="table-body text-center">
                      {i.document_file ? (
                        <a href={i.document_file} target="_blank" rel="noopener noreferrer">
                          <DocumentIcon />
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                      <td className="table-body text-end">
                        <Updatedocument i={i} getData={getDocument} />
                        <DeleteDocuments i={i} getDocument={getDocument} />
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              ))
            }
          </tbody>
        </table>
      </div>


    </div>
  )


}


export {
  BillTable,
  BillingDetailsTable,
  EOTTable,
  COSTable,
  EmployeeTable,
  LetterTracking,
  // LetterTable,
  // VehiclesTable,
  MilestoneTable,
  ProjectProgressBar,
  Progress,
  ConsultancyDetails,

  ContractorDetails,
  MiscellaneousDocument
};
